(function () {
    function updateStickyHeaderHeight() {
        var header = document.querySelector('.sticky-top');
        if (header) {
            document.documentElement.style.setProperty('--app-header-height', header.offsetHeight + 'px');
        }
    }
    updateStickyHeaderHeight();
    window.addEventListener('resize', updateStickyHeaderHeight);

    function updateFixedFooterHeight() {
        // Citeste POZITIA REALA calculata (nu doar clasa .fixed-bottom din
        // markup, care ramane neschimbata) - pe mobil, main.scss suprascrie
        // footer-ul la position:static (nu mai mananca spatiu permanent din
        // ecran), caz in care nu mai e nevoie de nicio rezervare de spatiu.
        // O singura sursa de adevar pt breakpoint (CSS), fara prag duplicat
        // aici in JS.
        var footer = document.querySelector('footer');
        var isFixed = footer && getComputedStyle(footer).position === 'fixed';
        document.documentElement.style.setProperty('--app-footer-height', isFixed ? footer.offsetHeight + 'px' : '0px');
    }
    updateFixedFooterHeight();
    window.addEventListener('resize', updateFixedFooterHeight);
    // ResizeObserver pe footer insusi - updateFixedFooterHeight() de mai sus
    // masoara offsetHeight o singura data, la incarcarea scriptului; daca
    // inaltimea REALA a footer-ului se schimba ulterior fara niciun resize de
    // fereastra (ex. siglele partenerilor din footer.html isi termina
    // incarcarea putin mai tarziu, capatand dimensiunea reala si impingand
    // footer-ul sa treaca pe un rand suplimentar), variabila CSS ramanea
    // "inghetata" la valoarea veche, mai mica - gasit empiric 2026-09-29,
    // footer-ul acoperea vizibil ultima sectiune de continut pe pagini
    // suficient de scurte (ex. /data-policy) la latimi de tableta (~768px).
    var footerEl = document.querySelector('footer');
    if (footerEl && window.ResizeObserver) {
        new ResizeObserver(updateFixedFooterHeight).observe(footerEl);
    }

    // Inaltimea tastaturii virtuale, sau 0 daca nu e deschisa. NU se poate deduce
    // doar din innerHeight - vv.height - vv.offsetTop: la gestul de tras in jos
    // (pull-to-refresh / rubber-band iOS) vv.offsetTop devine negativ si
    // vv.height variaza cu bara de adrese, deci formula "vede" o tastatura de
    // 40-90px si barele fixe (.form-actions-pinned/.filter-actions) urcau si
    // coborau animat = tremurau (raportat de user 2026-09-30, reprodus cu
    // visualViewport simulat). offsetTop se limiteaza la >= 0, iar sub un prag
    // (o tastatura reala are sute de px) rezultatul se ignora.
    // A doua bariera (revenire a tremuratului, 2026-09-30, pe un telefon real, la
    // gestul de tras in jos pe formular - pragul singur nu tine pe orice
    // dispozitiv): tastatura virtuala exista DOAR cat timp un camp editabil are
    // focus. Fara focus intr-un input/textarea/select, orice variatie de viewport
    // (bara de adrese, rubber-band, pull-to-refresh) e ignorata, deci barele fixe
    // nu se mai misca deloc din alte cauze decat tastatura.
    var KEYBOARD_MIN_HEIGHT = 150;
    function isEditableFocused() {
        var el = document.activeElement;
        if (!el) return false;
        var tag = el.tagName;
        return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable === true;
    }
    function virtualKeyboardHeight() {
        var vv = window.visualViewport;
        if (!vv || !isEditableFocused()) return 0;
        var h = window.innerHeight - vv.height - Math.max(0, vv.offsetTop);
        return h >= KEYBOARD_MIN_HEIGHT ? h : 0;
    }

    function initFilterActionsBars() {
        var mobileQuery = window.matchMedia('(max-width: 767.98px)');

        document.querySelectorAll('.filter-actions').forEach(function (actions) {
            var collapseEl = actions.closest('.collapse');
            if (!collapseEl) return;

            function updateHeight() {
                document.documentElement.style.setProperty('--filter-actions-height', actions.offsetHeight + 'px');
            }

            // pe telefon, tastatura virtuala micsoreaza window.visualViewport
            // fara sa micsoreze window.innerHeight (layout viewport) - un
            // "bottom: 0" fixat ar ramane ascuns sub tastatura. Repozitionam
            // bara sa stea chiar deasupra tastaturii cat timp e deschisa,
            // altfel deasupra footerului, ca inainte.
            function updateKeyboardOffset() {
                if (!collapseEl.classList.contains('filter-actions-pinned') || !window.visualViewport) {
                    actions.style.bottom = '';
                    return;
                }
                var keyboardHeight = virtualKeyboardHeight();
                var footerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--app-footer-height')) || 0;
                actions.style.bottom = Math.max(keyboardHeight, footerHeight) + 'px';
            }

            function unpin() {
                collapseEl.classList.remove('filter-actions-pinned');
                actions.style.bottom = '';
            }

            // Fixarea barei nu mai e neconditionata: panouri scurte (Fenologie,
            // Observatii - doar 2 date + un grup de checkbox-uri) au adesea
            // butoanele deja vizibile fara nicio fixare, caz in care fixarea
            // ar fi doar un dreptunghi suplimentar care acopera continut, fara
            // beneficiu (spre deosebire de Utilizatori, cu 9 campuri, unde
            // fara fixare ai scrola mult ca sa ajungi la butoane). De aceea
            // masuram la fiecare evaluare pozitia naturala (in flux, nepinuita)
            // a barei si pinuim doar daca ar iesi din zona vizibila fara asta -
            // se generalizeaza automat la orice panou de filtrare viitor, fara
            // nicio decizie manuala per pagina.
            function evaluate() {
                unpin();
                if (!mobileQuery.matches) return;

                var footerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--app-footer-height')) || 0;
                var visibleBottom = window.innerHeight - footerHeight;
                var wouldBeHidden = actions.getBoundingClientRect().bottom > visibleBottom;
                if (!wouldBeHidden) return;

                collapseEl.classList.add('filter-actions-pinned');
                updateHeight();
                updateKeyboardOffset();
            }

            collapseEl.addEventListener('shown.bs.collapse', evaluate);
            collapseEl.addEventListener('hidden.bs.collapse', unpin);

            window.addEventListener('resize', function () {
                if (!collapseEl.classList.contains('show')) return;
                evaluate();
            });

            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', updateKeyboardOffset);
                window.visualViewport.addEventListener('scroll', updateKeyboardOffset);
            }
        });
    }
    initFilterActionsBars();

    // Inchide panoul de filtrare la submit manual (click "Aplica filtru" sau
    // Enter intr-un camp text), dar NU la auto-apply-ul de pe checkbox/select
    // (hx-trigger="change[...]" din list-filter.html) - evenimentul nativ
    // 'submit' se declanseaza doar la primul caz; htmx il intercepteaza
    // separat pentru cererea AJAX, fara conflict cu inchiderea vizuala de aici.
    function initFilterPanelAutoClose() {
        document.querySelectorAll('[data-close-filter-panel-on-submit]').forEach(function (form) {
            form.addEventListener('submit', function () {
                var collapseEl = form.querySelector('.collapse.show');
                if (!collapseEl) return;
                bootstrap.Collapse.getOrCreateInstance(collapseEl).hide();
            });
        });
    }
    initFilterPanelAutoClose();

    // Selectul "Sortare" + iconita de directie din listarile pe mobil
    // (echivalentul mobil al antetului de coloana sortabil de pe desktop) -
    // un singur select de camp (vezi fragments/sort.html :: sortFieldOption)
    // + un buton tap-to-cycle (sortToggleButton) care cicleaza 3 stari
    // (ASC->DESC->implicit), exact ca sortLink() server-side. Directia
    // curenta/descFirst per camp vin din data-current-direction/data-desc-first
    // de pe optiunea selectata din <select> - o singura sursa de adevar,
    // butonul nu are stare proprie server-randata.
    function initSortSelects(root) {
        var scope = root || document;
        var containers = (scope.matches && scope.matches('[data-sort-base-url]')) ? [scope] : [];
        containers = containers.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-sort-base-url]')));
        containers.forEach(function (container) {
            var baseUrl = container.getAttribute('data-sort-base-url');
            var fieldSelect = container.querySelector('[data-sort-field-select]');
            var toggleBtn = container.querySelector('[data-sort-toggle]');
            if (!baseUrl || !fieldSelect || !toggleBtn) return;

            var icon = toggleBtn.querySelector('.sort-icon');

            function selectedOption() {
                return fieldSelect.options[fieldSelect.selectedIndex];
            }

            function render(direction) {
                icon.className = 'bi sort-icon ' + (direction === 'ASC' ? 'bi-sort-up text-body'
                    : direction === 'DESC' ? 'bi-sort-down text-body'
                    : 'bi-arrow-down-up text-muted opacity-50');
                var suffix = direction === 'ASC' ? 'asc' : direction === 'DESC' ? 'desc' : 'default';
                var text = toggleBtn.getAttribute('data-tooltip-' + suffix);
                toggleBtn.setAttribute('title', text);
                toggleBtn.setAttribute('aria-label', text);
            }

            function navigate(direction) {
                var sep = baseUrl.indexOf('?') !== -1 ? '&' : '?';
                if (direction === 'NONE') {
                    window.location.href = baseUrl + sep + 'page=1';
                    return;
                }
                var sortParams = fieldSelect.value.split(',').map(function (property) {
                    return 'sort=' + property + ',' + direction;
                }).join('&');
                window.location.href = baseUrl + sep + sortParams + '&page=1';
            }

            render(selectedOption().dataset.currentDirection);

            fieldSelect.addEventListener('change', function () {
                var descFirst = selectedOption().dataset.descFirst === 'true';
                navigate(descFirst ? 'DESC' : 'ASC');
            });

            toggleBtn.addEventListener('click', function () {
                var opt = selectedOption();
                var descFirst = opt.dataset.descFirst === 'true';
                var current = opt.dataset.currentDirection;
                var next = descFirst
                    ? (current === 'DESC' ? 'ASC' : (current === 'ASC' ? 'NONE' : 'DESC'))
                    : (current === 'ASC' ? 'DESC' : (current === 'DESC' ? 'NONE' : 'ASC'));
                navigate(next);
            });
        });
    }
    initSortSelects();

    // Re-ruleaza initSortSelects() pentru orice select mobil de sortare aparut
    // printr-un swap htmx (ex. listBody swap-uit dupa aplicarea automata a unui
    // filtru) — DOM-ul vechi (cu listenerii lui) e mereu distrus complet de
    // hx-swap="outerHTML" inainte sa existe cel nou, deci re-rularea aici nu
    // poate atasa listeneri dubli. Acelasi tipar ca initParentalConsentToggle
    // de mai jos.
    document.body.addEventListener('htmx:load', function (evt) {
        initSortSelects(evt.detail.elt);
    });

    // Bara fixa cu butonul Salvare (formularul de creare Fenologie, .form-actions-pinned)
    // e mereu prezenta pe mobil (spre deosebire de .filter-actions-pinned, nu e
    // conditionata de un panou care se deschide/inchide), asa ca aici doar
    // repozitionam deasupra tastaturii virtuale cat timp e deschisa - acelasi
    // calcul ca la updateKeyboardOffset din initFilterActionsBars.
    function initFormActionsPinned() {
        var mobileQuery = window.matchMedia('(max-width: 767.98px)');

        document.querySelectorAll('.form-actions-pinned').forEach(function (actions) {
            function updateKeyboardOffset() {
                if (!mobileQuery.matches || !window.visualViewport) {
                    actions.style.bottom = '';
                    return;
                }
                var keyboardHeight = virtualKeyboardHeight();
                var footerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--app-footer-height')) || 0;
                actions.style.bottom = Math.max(keyboardHeight, footerHeight) + 'px';
            }

            updateKeyboardOffset();
            window.addEventListener('resize', updateKeyboardOffset);
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', updateKeyboardOffset);
                window.visualViewport.addEventListener('scroll', updateKeyboardOffset);
            }
        });
    }
    initFormActionsPinned();

    // Afisare relativa a datei ("acum 5 minute") peste data absoluta randata
    // server-side (vezi fragments/relative-time.html) - progressive enhancement,
    // fallback-ul absolut ramane vizibil daca acest script nu ruleaza deloc.
    // Cuvintele traduse (RO, pluralizare) vin o singura data din data-rt-* de pe
    // <body> (randate din messages.properties, acelasi tipar ca data-tooltip-*
    // din initSortSelects/data-geo-text din initGeolocationCapture), regula
    // gramaticala "de" (peste 20) e logica fixa, nu text tradus.
    var RELATIVE_TIME_THRESHOLD_MS = 365 * 24 * 60 * 60 * 1000;
    var relativeTimeWords = null;

    function relativeTimeWordsCache() {
        if (!relativeTimeWords) {
            var d = document.body.dataset;
            relativeTimeWords = {
                justNow: d.rtJustNow,
                agoPrefix: d.rtAgoPrefix,
                oneMinute: d.rtOneMinute, minutes: d.rtMinutes,
                oneHour: d.rtOneHour, hours: d.rtHours,
                oneDay: d.rtOneDay, days: d.rtDays,
                oneWeek: d.rtOneWeek, weeks: d.rtWeeks,
                oneMonth: d.rtOneMonth, months: d.rtMonths,
                oneYear: d.rtOneYear, years: d.rtYears
            };
        }
        return relativeTimeWords;
    }

    function formatRelativeTime(diffMs) {
        var words = relativeTimeWordsCache();
        var sec = Math.floor(diffMs / 1000);
        if (sec < 60) return words.justNow;

        var min = Math.floor(sec / 60);
        var n, oneWord, many;
        if (min < 60) {
            n = min; oneWord = words.oneMinute; many = words.minutes;
        } else {
            var hr = Math.floor(min / 60);
            if (hr < 24) {
                n = hr; oneWord = words.oneHour; many = words.hours;
            } else {
                var day = Math.floor(hr / 24);
                if (day < 7) {
                    n = day; oneWord = words.oneDay; many = words.days;
                } else if (day < 30) {
                    n = Math.floor(day / 7); oneWord = words.oneWeek; many = words.weeks;
                } else if (day < 335) {
                    n = Math.floor(day / 30); oneWord = words.oneMonth; many = words.months;
                } else {
                    // Sub pragul de 1 an (RELATIVE_TIME_THRESHOLD_MS), zilele raman
                    // mereu in [335, 365) - rotunjirea da mereu 1 ("acum un an").
                    n = Math.round(day / 365); oneWord = words.oneYear; many = words.years;
                }
            }
        }
        if (n === 1) return words.agoPrefix + ' ' + oneWord;
        var numberPart = n >= 20 ? (n + ' de ') : (n + ' ');
        return words.agoPrefix + ' ' + numberPart + many;
    }

    // expus pt map.js (harta, B1 - varsta datelor in tooltip-ul butonului de
    // actualizare), ca sa nu dubleze nici logica, nici cuvintele traduse
    window.CaliTime = { formatRelative: formatRelativeTime };

    function updateRelativeTimeElements(root) {
        var scope = root || document;
        var now = Date.now();

        scope.querySelectorAll('[data-relative-time]').forEach(function (el) {
            var diff = now - new Date(el.getAttribute('data-relative-time')).getTime();
            if (diff < 0 || diff >= RELATIVE_TIME_THRESHOLD_MS) return;
            el.textContent = formatRelativeTime(diff);
        });

        // Ordinea "acum X (data absoluta)" - vezi fragments/relative-time.html
        // pt semantica completa a celor 2 span-uri (prefix relativ + paren absolut).
        // Fiecare span e propriul lui "chip" atomic (text-nowrap) - eventuala
        // ruptura de rand cade INTRE ele (la spatiul din markup), nu in interior.
        scope.querySelectorAll('[data-relative-time-suffix-prefix]').forEach(function (el) {
            var diff = now - new Date(el.getAttribute('data-relative-time-suffix-prefix')).getTime();
            el.textContent = (diff < 0 || diff >= RELATIVE_TIME_THRESHOLD_MS) ? '' : formatRelativeTime(diff);
        });

        scope.querySelectorAll('[data-relative-time-suffix-paren]').forEach(function (el) {
            var diff = now - new Date(el.getAttribute('data-relative-time-suffix-paren')).getTime();
            if (diff < 0 || diff >= RELATIVE_TIME_THRESHOLD_MS) return;
            if (!el.dataset.absoluteText) el.dataset.absoluteText = el.textContent;
            el.textContent = '(' + el.dataset.absoluteText + ')';
            el.classList.add('text-muted', 'small');
        });
    }
    updateRelativeTimeElements();
    setInterval(function () { updateRelativeTimeElements(document); }, 60000);

    document.body.addEventListener('htmx:load', function (evt) {
        updateRelativeTimeElements(evt.detail.elt);
    });

    function makeDraggable(modal, header) {
        var dialog = modal.querySelector('.modal-dialog');
        var dragging = false, startX, startY, startLeft, startTop;

        header.addEventListener('mousedown', function (e) {
            dragging = true;
            var rect = dialog.getBoundingClientRect();
            startX = e.clientX;
            startY = e.clientY;
            startLeft = rect.left;
            startTop = rect.top;
            dialog.style.width = rect.width + 'px';
            dialog.style.position = 'fixed';
            dialog.style.margin = '0';
            dialog.style.left = startLeft + 'px';
            dialog.style.top = startTop + 'px';
            document.body.style.userSelect = 'none';
        });

        document.addEventListener('mousemove', function (e) {
            if (!dragging) return;
            dialog.style.left = (startLeft + e.clientX - startX) + 'px';
            dialog.style.top = (startTop + e.clientY - startY) + 'px';
        });

        document.addEventListener('mouseup', function () {
            dragging = false;
            document.body.style.userSelect = '';
        });

        modal.addEventListener('hidden.bs.modal', function () {
            dialog.style.position = '';
            dialog.style.left = '';
            dialog.style.top = '';
            dialog.style.margin = '';
            dialog.style.width = '';
        });
    }

    var modal = document.getElementById('user-modal');
    document.querySelectorAll('.modal-draggable-header').forEach(function (header) {
        var draggableModal = header.closest('.modal');
        if (draggableModal) {
            makeDraggable(draggableModal, header);
        }
    });

    document.body.addEventListener('userSaved', function () {
        if (!modal) return;
        var instance = bootstrap.Modal.getInstance(modal);
        if (instance) instance.hide();
    });

    // acelasi mecanism ca userSaved de mai sus, pt formularul de review Ranger
    // (RangerController.review()) — la succes, raspunsul actualizeaza in-place
    // lista din care a pornit actiunea (swap OOB), fara nicio navigare, deci
    // modalul de review trebuie inchis explicit din JS, nu prin redirect
    var rangerReviewModal = document.getElementById('ranger-review-modal');
    document.body.addEventListener('reviewSaved', function () {
        if (!rangerReviewModal) return;
        var instance = bootstrap.Modal.getInstance(rangerReviewModal);
        if (instance) instance.hide();
    });

    // stergerea unei observatii din fereastra de detalii deschisa pe harta (returnTo=MAP,
    // vezi *Controller.delete()): serverul nu redirectioneaza, deci fereastra de detalii
    // a modulului se inchide explicit aici, la fel ca la reviewSaved
    document.body.addEventListener('observationDeleted', function () {
        ['phenology-modal', 'disturbance-modal', 'soil-modal'].forEach(function (id) {
            var el = document.getElementById(id);
            var instance = el && bootstrap.Modal.getInstance(el);
            if (instance) instance.hide();
        });
    });

    // mecanism generic "inchide un modal, deschide altul" — folosit de butonul
    // Review din phenology/view.html (inchide #phenology-modal, deschide
    // #ranger-review-modal), reutilizabil de orice tranzitie similara viitoare.
    // Delegat pe document.body (nu querySelectorAll+forEach o singura data la
    // incarcare) — butonul e continut in continut incarcat dinamic prin htmx
    // (fragmentul de detalii al modulului), nu exista inca in DOM la momentul
    // la care ar rula un querySelectorAll o singura data.
    document.body.addEventListener('click', function (evt) {
        var btn = evt.target.closest('[data-next-modal-target]');
        if (!btn) return;
        var currentModal = btn.closest('.modal');
        var nextModalEl = document.querySelector(btn.dataset.nextModalTarget);
        if (!currentModal || !nextModalEl) return;
        currentModal.addEventListener('hidden.bs.modal', function handler() {
            currentModal.removeEventListener('hidden.bs.modal', handler);
            bootstrap.Modal.getOrCreateInstance(nextModalEl).show();
        }, { once: true });
    });

    // starea formularului de review (ranger/review-form.html) depinde de
    // radio-ul Aproba/Respinge selectat: steluta de comentariu obligatoriu
    // apare doar la Respinge, checkbox-ul Arbore Sentinela apare doar la
    // Aproba (n-are sens la o observatie respinsa) — validarea ramane strict
    // server-side (RangerController + fieldError), fara required nativ HTML;
    // aici doar comutam vizibilitatea, acelasi tipar ca initParentalConsentToggle.
    // Sincronizat atat la schimbarea radio-ului cat si dupa fiecare swap htmx
    // (formularul poate reveni cu o selectie deja facuta, dupa o eroare de validare)
    function syncReviewFormState(root) {
        (root || document).querySelectorAll('[data-review-decision-group]').forEach(function (group) {
            var checked = group.querySelector('input[type=radio]:checked');
            var value = checked ? checked.value : null;
            var form = group.closest('form');
            var requiredMark = form ? form.querySelector('#reviewCommentRequiredMark') : null;
            if (requiredMark) {
                requiredMark.classList.toggle('d-none', value !== 'REJECT');
            }
            // togglata impreuna cu asteriscul de mai sus — vezi bug-ul documentat
            // in ranger/review-form.html (legenda ramanea vizibila la Aproba,
            // desi niciun asterisc nu mai apare pe ecran in acea stare)
            var requiredLegend = form ? form.querySelector('#reviewRequiredLegend') : null;
            if (requiredLegend) {
                requiredLegend.classList.toggle('d-none', value !== 'REJECT');
            }
            var sentinelGroup = form ? form.querySelector('#markSentinelGroup') : null;
            if (sentinelGroup) {
                var showSentinel = value === 'APPROVE';
                sentinelGroup.classList.toggle('d-none', !showSentinel);
                // bifa ramane in DOM cat timp grupul e doar ascuns (nu eliminat) —
                // curatata explicit la Respinge, ca sa nu se trimita markSentinel=true
                // "in spate" pt o decizie la care n-are niciun sens
                if (!showSentinel) {
                    var checkbox = sentinelGroup.querySelector('#markSentinel');
                    if (checkbox) checkbox.checked = false;
                }
            }
        });
    }

    syncReviewFormState();

    document.body.addEventListener('change', function (evt) {
        if (evt.target.matches('[data-review-decision-group] input[type=radio]')) {
            syncReviewFormState(evt.target.closest('form'));
        }
    });

    // rezumatul complet al observatiei (poze/GPS/stadiu, vezi
    // ranger/review-form.html) sta INAINTEA zonei de decizie (#reviewDecisionSection,
    // chenarul cu radio Aproba/Respinge + Sentinela + comentariu) — pe
    // observatii cu multe poze, zona de decizie poate ajunge sub fold la
    // deschiderea formularului, dand impresia gresita ca "nu e nimic de
    // aprobat". block:'start' (nu 'nearest', folosit la action-log-collapse
    // mai jos) — alinieaza chenarul la marginea de SUS a zonei vizibile, ca
    // sa se vada dedesubt si inceputul campului de comentariu, nu doar linia
    // cu radio-urile (block:'nearest' incercat initial, aducea in vizor STRICT
    // radio-urile, taind tot ce urma). Apelat din DOUA evenimente, oricare
    // vine ultimul — continutul poate ajunge inainte SAU dupa ce Bootstrap
    // termina tranzitia de deschidere a modalului (~300ms), iar un apel prea
    // devreme (inainte ca modalul sa fie complet afisat) nu are efect vizibil
    // (gasit empiric cu Playwright, 2026-08-03): htmx:load (continutul e gata)
    // si shown.bs.modal (modalul e complet afisat).
    function scrollToReviewDecisionSection() {
        var section = document.getElementById('reviewDecisionSection');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    document.body.addEventListener('htmx:load', function (evt) {
        syncReviewFormState(evt.detail.elt);
        scrollToReviewDecisionSection();
    });

    if (rangerReviewModal) {
        rangerReviewModal.addEventListener('shown.bs.modal', scrollToReviewDecisionSection);
    }

    // istoricul de actiuni (phenology/view.html) e ultimul rand din pagina —
    // la expandare, continutul revelat poate ramane in afara zonei vizibile
    // (pagina completa SAU .modal-scroll-content in modal), fara niciun
    // indiciu ca a aparut ceva. scrollIntoView cu block:'nearest' gaseste
    // automat cel mai apropiat container scrollabil (document SAU
    // .modal-scroll-content), fara sa forteze scroll daca deja e vizibil.
    // Scopat strict la .action-log-collapse (nu orice .collapse din
    // aplicatie) — un listener global ar prinde si #mainNavbar/panourile de
    // filtrare, unde un scroll automat nu e dorit.
    document.body.addEventListener('shown.bs.collapse', function (evt) {
        if (evt.target.classList.contains('action-log-collapse')) {
            evt.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    });

    var mobileHelpLink = document.getElementById('help-link-mobile');
    var mainNavbarEl = document.getElementById('mainNavbar');
    if (mobileHelpLink && mainNavbarEl) {
        mobileHelpLink.addEventListener('click', function () {
            bootstrap.Collapse.getOrCreateInstance(mainNavbarEl, { toggle: false }).hide();
        });
    }

    document.body.addEventListener('htmx:load', function (evt) {
        var el = evt.detail.elt;
        if (el.classList && el.classList.contains('toast') && !el.classList.contains('show')) {
            var toast = new bootstrap.Toast(el);
            toast.show();
        }
    });

    document.querySelectorAll('#toast-container .toast.show').forEach(function (el) {
        new bootstrap.Toast(el).show();
    });

    var confirmModalEl = document.getElementById('confirm-modal');
    var confirmModal = confirmModalEl ? new bootstrap.Modal(confirmModalEl) : null;
    var confirmBody = document.getElementById('confirm-modal-body');
    var confirmOkBtn = document.getElementById('confirm-modal-ok');
    var pendingConfirm = null;

    document.body.addEventListener('htmx:confirm', function (evt) {
        if (!confirmModal || !evt.detail.question) return;
        evt.preventDefault();
        confirmBody.textContent = evt.detail.question;
        pendingConfirm = evt.detail;
        confirmModal.show();
    });

    if (confirmOkBtn) {
        confirmOkBtn.addEventListener('click', function () {
            confirmModal.hide();
            if (pendingConfirm) {
                pendingConfirm.issueRequest(true);
                pendingConfirm = null;
            }
        });
    }

    // Reutilizeaza acelasi #confirm-modal pt o actiune JS PURA (fara htmx,
    // fara request server - ex. stergerea unui item din coada offline,
    // IndexedDB) - construieste un obiect "detail" sintetic cu aceeasi forma
    // ca evt.detail de la htmx:confirm ({ issueRequest }), ca handler-ul deja
    // existent al confirmOkBtn de mai sus sa nu aiba nevoie de nicio schimbare.
    function showConfirmModal(message, onConfirm) {
        if (!confirmModal) { onConfirm(); return; }
        confirmBody.textContent = message;
        pendingConfirm = { issueRequest: function () { onConfirm(); } };
        confirmModal.show();
    }

    function initParentalConsentToggle(root) {
        var scope = root || document;
        var forms = (scope.matches && scope.matches('[data-elev-role-code]')) ? [scope] : [];
        if (scope.querySelectorAll) {
            forms = forms.concat(Array.from(scope.querySelectorAll('[data-elev-role-code]')));
        }
        forms.forEach(function (form) {
            var elevCode = form.getAttribute('data-elev-role-code');
            var group = form.querySelector('#parentalConsentGroup');
            if (!group) return;
            var fileInput = group.querySelector('input[type="file"]');
            var requiredMark = group.querySelector('#parentalConsentRequiredMark');
            var hasExisting = group.getAttribute('data-has-existing-file') === 'true';
            function update() {
                var checked = form.querySelector('input[name="roleIds"][value="' + elevCode + '"]:checked');
                var required = !!checked && !hasExisting;
                group.classList.toggle('d-none', !checked);
                if (fileInput) fileInput.required = required;
                if (requiredMark) requiredMark.classList.toggle('d-none', !required);
            }
            form.querySelectorAll('input[name="roleIds"]').forEach(function (r) {
                r.addEventListener('change', update);
            });
            update();
        });
    }
    initParentalConsentToggle(document);

    document.body.addEventListener('htmx:load', function (evt) {
        initParentalConsentToggle(evt.detail.elt);
    });

    function initPasswordToggles() {
        document.querySelectorAll('.password-toggle').forEach(function (btn) {
            var input = document.getElementById(btn.getAttribute('data-target-id'));
            var icon = btn.querySelector('i');
            if (!input || !icon) return;
            btn.addEventListener('click', function () {
                var show = input.type === 'password';
                input.type = show ? 'text' : 'password';
                icon.classList.toggle('bi-eye', !show);
                icon.classList.toggle('bi-eye-slash', show);
            });
        });
    }
    initPasswordToggles();

    // Populeaza campul ascuns "standalonePwa" de pe formularul de login, CITIT
    // de SecurityConfig (RememberMeConfigurer.rememberMeParameter) ca sa decida
    // daca activeaza cookie-ul persistent remember-me - fix delogare la
    // redeschiderea PWA-ului instalat (JSESSIONID e sters de OS/WebKit la
    // inchiderea completa a ferestrei standalone). NU e un checkbox ales de
    // user - display-mode nu se schimba in timpul vietii paginii, deci se
    // calculeaza o singura data, la incarcare, nu la submit. navigator.standalone
    // e fallback pt Safari/iOS mai vechi, unde matchMedia('display-mode:
    // standalone') nu e suportat.
    function initRememberMeStandaloneDetection() {
        var field = document.getElementById('standalonePwaFlag');
        if (!field) return;
        var isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone === true;
        field.value = isStandalone ? 'true' : 'false';
    }
    initRememberMeStandaloneDetection();

    // -- Captura geolocatiei la submit (Fenologie/Perturbari/Sol) --------------
    // coordonatele trebuie capturate la momentul Submit-ului (nu la deschiderea
    // formularului) - interceptam primul submit, cerem pozitia, completam
    // campurile ascunse si retrimitem formularul o singura data (marcat prin
    // data-geo-captured, ca sa nu intram intr-o bucla infinita).
    // showGeoErrorToast/attemptGeolocationCapture sunt functii de NIVEL SUPERIOR
    // (nu imbricate in initGeolocationCapture) - trebuie apelabile si de pe
    // butonul "Reincercati" al overlay-ului de eroare GPS (definit mai jos in
    // fisier), nu doar din listener-ul de submit; hoisting-ul functiilor le
    // face accesibile oriunde in acest IIFE, indiferent de ordinea din sursa.
    function showGeoErrorToast(messageElId) {
        var toastEl = document.getElementById('geo-error-toast');
        var bodyEl = document.getElementById('geo-error-toast-body');
        var msgEl = document.getElementById(messageElId);
        if (!toastEl || !bodyEl || !msgEl) return;
        bodyEl.textContent = msgEl.textContent;
        new bootstrap.Toast(toastEl).show();
    }

    // -- Captare GPS: watch continuu in fundal (rezerva) + indicator live -------
    // A2 (rezerva) + A1 (indicator de precizie), vezi CLAUDE.md radacina, sectiunea
    // GPS. La deschiderea unui formular cu data-geolocation-required pornim un
    // watchPosition silentios, care tine la zi ULTIMA pozitie cunoscuta
    // (gpsWatchLast) si actualizeaza indicatorul live (precizia curenta, cu
    // avertizare peste prag). Captarea PRINCIPALA ramane la momentul Submit
    // (acquirePosition) - rezerva din fundal e folosita DOAR daca aceea esueaza,
    // marcata gps_source=BACKGROUND, ca sa nu fie confundata cu o pozitie proaspata.
    var gpsWatchId = null;
    var gpsWatchLast = null;

    function updateGpsIndicator(state, position) {
        var el = document.querySelector('[data-gps-indicator]');
        if (!el) return;
        var textEl = el.querySelector('[data-gps-indicator-text]');
        if (!textEl) return;
        var threshold = parseFloat(el.dataset.gpsThreshold) || 30;
        el.classList.remove('text-muted', 'text-warning-emphasis', 'text-danger');
        if (state === 'unavailable') {
            el.classList.add('text-danger');
            textEl.textContent = el.dataset.textUnavailable || '';
        } else if (state === 'fix' && position) {
            var accuracy = position.coords.accuracy;
            var rounded = new Intl.NumberFormat('ro-RO').format(Math.round(accuracy));
            if (accuracy > threshold) {
                el.classList.add('text-warning-emphasis');
                textEl.textContent = (el.dataset.textWarning || '').replace('{0}', rounded);
            } else {
                el.classList.add('text-muted');
                textEl.textContent = (el.dataset.textAccuracy || '').replace('{0}', rounded);
            }
        } else {
            el.classList.add('text-muted');
            textEl.textContent = el.dataset.textSearching || '';
        }
    }

    function startGpsWatch() {
        if (gpsWatchId !== null) return;
        if (!document.querySelector('form[data-geolocation-required]')) return;
        if (!('geolocation' in navigator)) {
            updateGpsIndicator('unavailable');
            return;
        }
        updateGpsIndicator('searching');
        gpsWatchId = navigator.geolocation.watchPosition(function (position) {
            gpsWatchLast = position;
            updateGpsIndicator('fix', position);
        }, function (err) {
            // PERMISSION_DENIED (code 1) e definitiv; timeout/indisponibil
            // trec, watch-ul continua - pastram ultima pozitie buna daca exista
            if (!gpsWatchLast) {
                updateGpsIndicator(err && err.code === 1 ? 'unavailable' : 'searching');
            } else if (err && err.code === 1) {
                gpsWatchLast = null;
                updateGpsIndicator('unavailable');
            }
        }, { enableHighAccuracy: true, maximumAge: 0 });
    }

    function stopGpsWatch() {
        if (gpsWatchId !== null) {
            navigator.geolocation.clearWatch(gpsWatchId);
            gpsWatchId = null;
        }
    }

    startGpsWatch();
    // Renuntare/navigare/submit reusit/reincarcare dupa punerea in coada:
    // toate distrug pagina => pagehide. Pagina restaurata din bfcache (pageshow
    // persisted) nu si-ar reporni singura watch-ul oprit.
    window.addEventListener('pagehide', stopGpsWatch);
    window.addEventListener('pageshow', function (evt) {
        if (evt.persisted) startGpsWatch();
    });

    function getPositionOnce(options) {
        return new Promise(function (resolve, reject) {
            navigator.geolocation.getCurrentPosition(resolve, reject, options);
        });
    }

    // Captarea principala la Submit: precizie inalta (10s), apoi o singura
    // reincercare scurta cu precizie redusa (localizare de retea) - mai bine o
    // pozitie aproximativa (cu accuracy mare, vizibila) decat niciuna; la esec
    // total, ultima pozitie din fundal (source BACKGROUND); altfel respinge.
    function acquirePosition() {
        return getPositionOnce({ enableHighAccuracy: true, timeout: 10000, maximumAge: 0 })
            .catch(function (err) {
                if (err && err.code === 1) throw err; // permisiune refuzata - reincercarea n-are rost
                return getPositionOnce({ enableHighAccuracy: false, timeout: 6000, maximumAge: 0 });
            })
            .then(function (position) {
                return { position: position, source: 'SUBMIT' };
            })
            .catch(function (err) {
                if (gpsWatchLast) return { position: gpsWatchLast, source: 'BACKGROUND' };
                throw err;
            });
    }

    function setGeoField(form, selector, value) {
        var field = form.querySelector(selector);
        if (field) field.value = (value === null || value === undefined || (typeof value === 'number' && !isFinite(value))) ? '' : value;
    }

    function fillGpsFields(form, result) {
        var position = result.position;
        setGeoField(form, '[data-geo-lat]', position.coords.latitude);
        setGeoField(form, '[data-geo-lon]', position.coords.longitude);
        setGeoField(form, '[data-geo-accuracy]', position.coords.accuracy);
        setGeoField(form, '[data-geo-altitude]', position.coords.altitude);
        setGeoField(form, '[data-geo-timestamp]',
            isFinite(position.timestamp) ? formatLocalDateTimeForServer(position.timestamp) : '');
        setGeoField(form, '[data-geo-source]', result.source);
    }

    function attemptGeolocationCapture(form, submitter) {
            var buttons = form.querySelectorAll('button[type="submit"]');

            function submitFormNow() {
                if (typeof form.requestSubmit === 'function') {
                    form.requestSubmit();
                } else {
                    form.submit();
                }
            }

            // "Browser nesuportat" ramane pe toast, nu overlay - nu exista
            // niciun pas de verificat/reincercat (checklist-ul overlay-ului
            // n-ar avea sens aici, e o limitare de browser, nu de GPS/retea)
            if (!('geolocation' in navigator)) {
                showGeoErrorToast('geo-msg-unsupported');
                return;
            }

            buttons.forEach(function (btn) { btn.disabled = true; });
            // Overlay-ul global pornește AICI, nu la retrimiterea finală de mai
            // jos — altfel userul vede o pauză tăcută (doar butoanele disabled,
            // fără spinner) cât timp navigator.geolocation.getCurrentPosition()
            // caută semnal GPS (enableHighAccuracy, poate dura câteva secunde),
            // înainte ca overlay-ul să apară abia la request-ul multipart real.
            // Text distinct ("Se determină geolocația", din data-geo-text) cât
            // timp așteptăm poziția — retrimiterea reală de mai jos declanșează
            // propriul beginLoading() FĂRĂ mesaj (prin listener-ul generic de
            // submit), care revine automat la textul implicit "Vă rugăm să
            // așteptați" pt faza de upload — două overlay-uri succesive, cu
            // texte diferite, nu doar unul întârziat. Contorul loadingActiveCount
            // suportă suprapunerea; la eroare se închide explicit.
            beginLoading(loadingOverlayEl && loadingOverlayEl.dataset.geoText);

            // A2: captare principala la Submit (cu reincercare cu precizie redusa),
            // iar la esec - ultima pozitie tinuta la zi in fundal de watchPosition
            // (vezi acquirePosition/startGpsWatch) - doar daca si aceea lipseste
            // se ajunge la overlay-ul de eroare
            acquirePosition().then(function (result) {
                fillGpsFields(form, result);
                form.dataset.geoCaptured = 'true';
                // requestSubmit(submitter) nu include in mod fiabil perechea
                // nume/valoare a butonului de submit pentru formulare
                // multipart/form-data (verificat empiric) - adaugam explicit
                // un input ascuns cu acea pereche inainte de retrimitere.
                if (submitter && submitter.name) {
                    var hiddenAction = document.createElement('input');
                    hiddenAction.type = 'hidden';
                    hiddenAction.name = submitter.name;
                    hiddenAction.value = submitter.value;
                    form.appendChild(hiddenAction);
                }

                // formularele modulelor de observatii de teren (data-module-type,
                // vezi phenology/disturbance/soil "new.html") au si un fallback
                // offline - restul formularelor cu geolocatie (daca vor aparea
                // vreodata) pastreaza comportamentul vechi, necondiționat
                if (!form.hasAttribute('data-module-type')) {
                    submitFormNow();
                    return;
                }

                probeConnectivity(form).then(function (connectivity) {
                    if (connectivity === 'ONLINE') {
                        submitFormNow();
                        // Plasa de siguranta (b) - vezi scheduleSlowSubmitFallback().
                        // Doar aici, nu si pe ramura "!form.hasAttribute('data-module-type')"
                        // de mai sus - acele formulare (ipotetice, azi inexistente)
                        // pastreaza deliberat comportamentul vechi, necondiționat.
                        scheduleSlowSubmitFallback(buttons);
                        return;
                    }
                    // conexiune absenta SAU prea lenta pt pozele atasate (estimat
                    // din proba de mai sus) - nu facem submit real (ar ramane
                    // blocat minute intregi sau ar esua tacut) - scriem
                    // observatia in coada IndexedDB si incheiem overlay-ul de
                    // incarcare aici (nu mai urmeaza nicio navigare reala imediat)
                    endLoading(true);
                    queueObservationOffline(form, connectivity).catch(function (err) {
                        buttons.forEach(function (btn) { btn.disabled = false; });
                        // Bug real gasit prin testare (2026-08-12): la un esec
                        // care NU reincarca pagina (QUEUE_FULL, sau INCOMPLETE
                        // de mai sus - userul ramane pe acelasi formular ca sa
                        // corecteze), form.dataset.geoCaptured a ramas 'true' de
                        // la aceasta incercare - fara resetare, un al doilea
                        // click pe Salvare ar fi ignorat complet de listener-ul
                        // de submit (vezi initGeolocationCapture, verifica exact
                        // acest flag), lasand submit-ul NATIV sa treaca direct,
                        // netratat, care offline esueaza urat, fara toast/coada.
                        delete form.dataset.geoCaptured;
                        showOfflineErrorToast(err);
                    });
                });
            }, function () {
                // orice alta eroare (permisiune refuzata, pozitie indisponibila,
                // timeout) - un singur ecran generic de checklist, nu 3 mesaje
                // separate ca inainte (vezi showGeoErrorOverlay)
                endLoading(true);
                buttons.forEach(function (btn) { btn.disabled = false; });
                showGeoErrorOverlay(form, submitter);
            });
    }

    // Plasa de siguranta (b) pt calea ONLINE a submit-ului - submitFormNow()
    // e un POST HTML nativ (nu fetch), fara AbortController, deci acest timer
    // NU poate anula/interoga cererea reala, doar reface starea vizibila a
    // paginii dupa ce loadingSafetyTimer (60s, beginLoading()) a ascuns deja
    // overlay-ul, fara nicio explicatie (bug raportat 2026-08-31, poza mare +
    // conexiune care s-a degradat DUPA proba de conectivitate, sau pur si
    // simplu mai lenta decat estimarea din probeConnectivity()). Daca submit-ul
    // reuseste sau navigheaza inainte de 60s, documentul curent e inlocuit -
    // acest setTimeout nu mai apuca sa ruleze, fara nevoie de clearTimeout
    // explicit.
    function scheduleSlowSubmitFallback(buttons) {
        setTimeout(function () {
            buttons.forEach(function (btn) { btn.disabled = false; });
            showSlowSubmitToast();
        }, 60000);
    }

    function initGeolocationCapture() {
        document.addEventListener('submit', function (evt) {
            var form = evt.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (!form.hasAttribute('data-geolocation-required')) return;
            if (form.dataset.geoCaptured === 'true') return;

            evt.preventDefault();
            attemptGeolocationCapture(form, evt.submitter);
        }, true);
    }
    initGeolocationCapture();

    // -- Overlay de eroare GPS (permisiune refuzata / pozitie indisponibila) ---
    // Ecran generic (nu 3 variante de mesaj ca vechiul toast) - checklistul de
    // verificat (permisiuni/locatie activata/aer liber) acopera rezonabil
    // ambele cauze reale posibile aici, fara sa oblige userul sa deduca ce
    // anume a esuat. Suprapune bannerul offline daca era vizibil (discutat
    // explicit cu userul, varianta aleasa) - ascuns cat timp overlay-ul e activ,
    // restaurat la inchidere (Reincercati SAU Anulati observatia).
    var geoErrorOverlayEl = document.getElementById('geo-error-overlay');
    var geoErrorOverlayActive = false;
    var geoErrorContext = null;

    function showGeoErrorOverlay(form, submitter) {
        geoErrorContext = { form: form, submitter: submitter };
        geoErrorOverlayActive = true;
        if (geoErrorOverlayEl) geoErrorOverlayEl.classList.remove('d-none');
        refreshOfflineBanner();
    }

    function hideGeoErrorOverlay() {
        geoErrorOverlayActive = false;
        if (geoErrorOverlayEl) geoErrorOverlayEl.classList.add('d-none');
        refreshOfflineBanner();
    }

    function initGeoErrorOverlay() {
        if (!geoErrorOverlayEl) return;
        var body = document.body;

        var titleEl = document.getElementById('geo-error-overlay-title');
        if (titleEl) titleEl.textContent = body.dataset.geoOverlayTitle || '';
        var descEl = document.getElementById('geo-error-overlay-description');
        if (descEl) descEl.textContent = body.dataset.geoOverlayDescription || '';
        var checkPermissionsEl = document.getElementById('geo-error-overlay-check-permissions');
        if (checkPermissionsEl) checkPermissionsEl.textContent = body.dataset.geoOverlayCheckPermissions || '';
        var checkLocationEl = document.getElementById('geo-error-overlay-check-location');
        if (checkLocationEl) checkLocationEl.textContent = body.dataset.geoOverlayCheckLocation || '';
        var checkOutdoorsEl = document.getElementById('geo-error-overlay-check-outdoors');
        if (checkOutdoorsEl) checkOutdoorsEl.textContent = body.dataset.geoOverlayCheckOutdoors || '';

        var retryBtn = document.getElementById('geo-error-overlay-retry');
        if (retryBtn) {
            retryBtn.textContent = body.dataset.geoOverlayRetry || '';
            retryBtn.addEventListener('click', function () {
                if (!geoErrorContext) return;
                var ctx = geoErrorContext;
                hideGeoErrorOverlay();
                attemptGeolocationCapture(ctx.form, ctx.submitter);
            });
        }

        var cancelBtn = document.getElementById('geo-error-overlay-cancel');
        if (cancelBtn) {
            cancelBtn.textContent = body.dataset.geoOverlayCancel || '';
            cancelBtn.addEventListener('click', function () {
                var ctx = geoErrorContext;
                hideGeoErrorOverlay();
                var link = ctx && ctx.form && ctx.form.querySelector('[data-cancel-link]');
                if (link) window.location.href = link.href;
            });
        }
    }
    initGeoErrorOverlay();

    // Unele browsere (mai ales mobil/Android) restaureaza fisierul selectat
    // intr-un input type="file" dupa un POST-redirect-GET catre acelasi URL,
    // desi documentul e complet nou (nu tine de bfcache si nu e afectat de
    // autocomplete="off") - golim explicit orice astfel de camp de pe
    // formularele modulelor de observatii de teren la fiecare incarcare.
    document.querySelectorAll('form[data-geolocation-required] input[type="file"]').forEach(function (input) {
        input.value = '';
    });

    // Acumuleaza fisierele dintr-un grup de input-uri type="file" de-a lungul
    // mai multor selectii succesive - implicit, un input isi inlocuieste
    // selectia la fiecare deschidere. Relevant mai ales pentru inputul de
    // camera foto (capture), unde fiecare apasare intoarce o singura poza si
    // utilizatorul se asteapta ca pozele facute succesiv sa se adauge, nu sa
    // se inlocuiasca reciproc. Randeaza si un preview cu thumbnail-uri +
    // buton de eliminare individuala pentru fiecare poza acumulata (din
    // oricare input al grupului).
    //
    // Limitele reale de la server (app.storage.max-file-size-mb/max-request-size-mb,
    // settings.properties) - expuse client-side prin data-storage-* pe <body>
    // (layouts/layout.html), NU un numar separat hardcodat aici, ca sa ramana
    // in oglinda exacta cu ce ar respinge oricum serverul. Verificate ATAT la
    // alegerea pozei (aici, prevenire) CAT si la sincronizarea din coada
    // offline (syncOneRecord() mai jos, plasa de siguranta) - vezi CLAUDE.md
    // radacina, analiza 2026-08-31 (poza mare ajunsa in coada, sincronizare
    // esuata tacut - fetch() nu primeste un raspuns HTTP curat de la server
    // in acest caz, MaxUploadSizeExceededException fiind aruncata din
    // MultipartFilter, INAINTE de DispatcherServlet - "Failed to fetch",
    // eroare de retea, imposibil de distins de o problema reala de conexiune;
    // singura cale fiabila e sa NU se ajunga niciodata acolo).
    // Limitele vin DOAR din <body> (layout.html), fara valori implicite copiate
    // aici - codul care le foloseste ruleaza doar pe pagini cu layout.html.
    var STORAGE_MAX_FILE_SIZE_MB = document.body.dataset.storageMaxFileSizeMb;
    var STORAGE_MAX_REQUEST_SIZE_MB = document.body.dataset.storageMaxRequestSizeMb;
    var STORAGE_MAX_FILE_SIZE_BYTES = parseFloat(STORAGE_MAX_FILE_SIZE_MB) * 1024 * 1024;
    var STORAGE_MAX_REQUEST_SIZE_BYTES = parseFloat(STORAGE_MAX_REQUEST_SIZE_MB) * 1024 * 1024;

    // Alege forma de plural romaneasca a unui mesaj (one/few/other) pt n;
    // interpolarea ramane la apelant. Categoriile vin din Intl.PluralRules
    // (regulile CLDR, aceleasi ca in Java) - nu dintr-o regula scrisa de mana:
    // "101 observații" e few, nu "101 de observații".
    var PLURAL_RULES_RO = new Intl.PluralRules('ro');
    function pluralText(n, texts) {
        return texts[PLURAL_RULES_RO.select(n)] || texts.other || '';
    }

    // "nume.jpg" sau "nume.jpg" și încă N poze - folosit la interpolarea {0}
    // din storage.photoTooLargeWarning/photoTotalTooLargeWarning (vezi mai jos).
    // Textele (storage.photoListMore.*) stau pe toast-ul care le foloseste.
    function fileListSummary(files, toastEl) {
        var first = '„' + files[0].name + '”';
        if (files.length === 1) return first;
        var d = toastEl.dataset;
        var rest = files.length - 1;
        return pluralText(rest, { one: d.listMoreOne, few: d.listMoreFew, other: d.listMoreOther })
            .replace('{0}', first).replace('{1}', rest);
    }

    function showPhotoSizeToast(tooLargeFiles, tooManyFiles) {
        var toastEl = document.getElementById('photo-size-toast');
        var bodyEl = document.getElementById('photo-size-toast-body');
        if (!toastEl || !bodyEl) return;
        var messages = [];
        if (tooLargeFiles.length) {
            messages.push((document.body.dataset.storagePhotoTooLarge || '')
                .replace('{0}', fileListSummary(tooLargeFiles, toastEl)).replace('{1}', STORAGE_MAX_FILE_SIZE_MB));
        }
        if (tooManyFiles.length) {
            messages.push((document.body.dataset.storagePhotoTotalTooLarge || '')
                .replace('{0}', fileListSummary(tooManyFiles, toastEl)).replace('{1}', STORAGE_MAX_REQUEST_SIZE_MB));
        }
        bodyEl.textContent = messages.join(' ');
        new bootstrap.Toast(toastEl).show();
    }

    // Markup asteptat: un container cu [data-accumulate-group] care contine
    // unul sau mai multe input[type=file][data-accumulate] si un container
    // [data-accumulate-preview] (optional data-remove-label pt aria-label).
    function initAccumulatingFileInputs() {
        document.querySelectorAll('[data-accumulate-group]').forEach(function (group) {
            var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="file"][data-accumulate]'));
            var previewEl = group.querySelector('[data-accumulate-preview]');
            var removeLabel = (previewEl && previewEl.dataset.removeLabel) || 'Elimină';
            var accumulatedByInput = new Map();
            var objectUrls = [];
            inputs.forEach(function (input) { accumulatedByInput.set(input, []); });

            function rebuildInputFiles(input) {
                var dataTransfer = new DataTransfer();
                accumulatedByInput.get(input).forEach(function (file) { dataTransfer.items.add(file); });
                input.files = dataTransfer.files;
            }

            function totalAccumulatedBytes() {
                var total = 0;
                accumulatedByInput.forEach(function (files) {
                    files.forEach(function (f) { total += f.size; });
                });
                return total;
            }

            function renderPreview() {
                if (!previewEl) return;
                objectUrls.forEach(function (url) { URL.revokeObjectURL(url); });
                objectUrls = [];
                previewEl.innerHTML = '';
                inputs.forEach(function (input) {
                    accumulatedByInput.get(input).forEach(function (file, index) {
                        var url = URL.createObjectURL(file);
                        objectUrls.push(url);

                        var item = document.createElement('div');
                        item.className = 'photo-preview-item';

                        var img = document.createElement('img');
                        img.src = url;
                        img.alt = file.name;
                        img.className = 'photo-preview-thumb';

                        var removeBtn = document.createElement('button');
                        removeBtn.type = 'button';
                        removeBtn.className = 'btn-close photo-preview-remove';
                        removeBtn.setAttribute('aria-label', removeLabel);
                        removeBtn.addEventListener('click', function () {
                            accumulatedByInput.get(input).splice(index, 1);
                            rebuildInputFiles(input);
                            renderPreview();
                        });

                        item.appendChild(img);
                        item.appendChild(removeBtn);
                        previewEl.appendChild(item);
                    });
                });
            }

            inputs.forEach(function (input) {
                input.addEventListener('change', function () {
                    if (!input.files || !input.files.length) return;

                    // Prevenire (nu doar raportare) - vezi comentariul de la
                    // STORAGE_MAX_FILE_SIZE_BYTES mai sus: o poza pe care
                    // serverul ar respinge-o oricum nu trebuie sa ajunga
                    // niciodata acumulata/trimisa (online SAU offline).
                    var tooLarge = [];
                    var underFileLimit = [];
                    Array.from(input.files).forEach(function (file) {
                        if (file.size > STORAGE_MAX_FILE_SIZE_BYTES) {
                            tooLarge.push(file);
                        } else {
                            underFileLimit.push(file);
                        }
                    });

                    var tooMany = [];
                    var accepted = [];
                    var runningTotal = totalAccumulatedBytes();
                    underFileLimit.forEach(function (file) {
                        if (runningTotal + file.size > STORAGE_MAX_REQUEST_SIZE_BYTES) {
                            tooMany.push(file);
                        } else {
                            runningTotal += file.size;
                            accepted.push(file);
                        }
                    });

                    accumulatedByInput.set(input, accumulatedByInput.get(input).concat(accepted));
                    rebuildInputFiles(input);
                    renderPreview();

                    if (tooLarge.length || tooMany.length) showPhotoSizeToast(tooLarge, tooMany);
                });
            });
        });
    }
    initAccumulatingFileInputs();

    // disturbance/new.html: campul "Tip insecta" e vizibil doar cand "Atac
    // insecte" (type_1) e bifat (pur CSS :has(), vezi main.scss) - dar valoarea
    // introdusa acolo ramane in DOM (si s-ar trimite la submit) chiar daca
    // userul debifeaza ulterior "Atac insecte" fara sa fi sters manual textul.
    // Golire explicita la debifare, ca formularul sa nu trimita niciodata un
    // tip de insecta orfan, fara sens, pt o observatie care nu mai e (si)
    // Atac insecte.
    function initDisturbanceInsectTypeClear() {
        var insectAttackCheckbox = document.getElementById('type_1');
        var insectTypeInput = document.getElementById('insectType');
        if (!insectAttackCheckbox || !insectTypeInput) return;

        insectAttackCheckbox.addEventListener('change', function () {
            if (!insectAttackCheckbox.checked) {
                insectTypeInput.value = '';
            }
        });
    }
    initDisturbanceInsectTypeClear();

    // fragments/species.html: "Precizati specia" apare doar cand specia aleasa e
    // "Alta specie" (OTHER); la orice alta alegere se ascunde SI se goleste, ca
    // un text ramas dintr-o alegere anterioara sa nu fie trimis (serverul il ignora
    // oricum - SpeciesSelection.create() - dar coada offline ar pastra un camp orfan).
    // Starea initiala (re-randare cu erori) vine deja corecta din server (d-none).
    function initSpeciesSelect() {
        document.querySelectorAll('[data-species-select]').forEach(function (select) {
            var form = select.closest('form');
            var group = form ? form.querySelector('[data-species-other-group]') : null;
            if (!group) return;
            var input = group.querySelector('input');

            select.addEventListener('change', function () {
                var isOther = select.value === 'OTHER';
                group.classList.toggle('d-none', !isOther);
                if (!isOther && input) input.value = '';
            });
        });
    }
    initSpeciesSelect();

    // settings/edit.html: hint dinamic sub grupul de radio-uri de protocol SMTP -
    // arata STRICT portul uzual al protocolului selectat, fara nicio comparare cu
    // portul introdus efectiv (decizie explicita a userului - hint simplu, nu
    // avertizare de nepotrivire).
    //
    // Actualizare 2026-09-07 (a doua, la cererea userului): un al doilea rand,
    // AFISAT DEASUPRA portului uzual, explica pe scurt ce inseamna protocolul
    // selectat (ex. "Conexiunea incepe necriptata, apoi trece la criptare TLS
    // imediat dupa conectare." pt STARTTLS) - userul intrebase daca poate
    // combina orice protocol cu orice port (da, tehnic, nicio validare nu
    // blocheaza asta), iar explicatia ajuta sa se inteleaga DE CE o combinatie
    // gresita esueaza la conectare, nu doar CE port e uzual. Cele 2 randuri sunt
    // 2 span-uri separate (#mailSecurityProtocolExplanation/#mailSecurityProtocolPortHint),
    // nu un singur text concatenat - fiecare traieste in propria cheie de
    // mesaj (*.explanation/*.hint), usor de intretinut separat.
    //
    // Actualizare 2026-09-07, la cererea userului (dupa un test real esuat -
    // protocol SMTP setat pe un protocol diferit de portul introdus, 465, produce
    // "Got bad greeting"/timeout, vezi CLAUDE.md): portul se auto-completeaza acum
    // cu valoarea uzuala a protocolului nou ales - DOAR la o schimbare REALA facuta
    // de user (evenimentul 'change' pe radio), NICIODATA la incarcarea initiala a
    // paginii (updateHint() de mai jos e apelata direct, nu printr-un eveniment
    // dispatch-uit, deci nu declanseaza acest listener) - altfel s-ar suprascrie
    // silentios un port deja salvat in DB la simpla deschidere a formularului.
    // Userul poate oricand retasta un port propriu dupa schimbarea protocolului -
    // campul ramane liber editabil, nu blocat. Valoarea uzuala (data-usual-port)
    // vine din MailSecurityProtocol.usualPort() (Java, sursa unica de adevar),
    // NU dedusa din textul tradus al hint-ului de mai jos.
    function initMailSecurityProtocolHint() {
        var radios = document.querySelectorAll('[data-mail-security-protocol-radio]');
        var hint = document.getElementById('mailSecurityProtocolHint');
        var explanationEl = document.getElementById('mailSecurityProtocolExplanation');
        var portHintEl = document.getElementById('mailSecurityProtocolPortHint');
        var portInput = document.getElementById('mailPort');
        if (!radios.length || !hint) return;

        function updateHint() {
            var checked = document.querySelector('[data-mail-security-protocol-radio]:checked');
            if (explanationEl) {
                explanationEl.textContent = checked ? checked.getAttribute('data-protocol-explanation') : '';
            }
            if (portHintEl) {
                portHintEl.textContent = checked ? checked.getAttribute('data-usual-port-hint') : '';
            }
        }

        function updatePortDefault(evt) {
            if (!portInput) return;
            var usualPort = evt.target.getAttribute('data-usual-port');
            if (usualPort) {
                portInput.value = usualPort;
            }
        }

        radios.forEach(function (radio) {
            radio.addEventListener('change', updateHint);
            radio.addEventListener('change', updatePortDefault);
        });
        updateHint();
    }
    initMailSecurityProtocolHint();

    // soil/new.html: sliderele CUPLATE ale compozitiei solului, cu lacat optional
    // per rand. Istoric: 3 clase cu regula "vecinilor" (2026-08-11, algoritmul
    // proportional respins ca imprevizibil); din 2026-09-30 (B2 cat. 2) 4 clase -
    // Muschi, Litiera, Plante, Sol gol - si regula "Sol gol preia" (varianta 5
    // din docs/mockup-soil-4-classes-sliders.html, aleasa de user dupa compararea
    // a 4 reguli; "neatinsul preia" respinsa ca greu de inteles):
    //  - PORNIRE GOALA: toate la 0 (SoilController.newForm), afisate "–", lacatele
    //    dezactivate, totalul neutru. La PRIMA atingere, valoarea trasa ramane, iar
    //    restul pana la 100 se imparte EGAL intre celelalte (resturile de 5% pe
    //    rand, de sus in jos) - pe toata durata primei trageri, pana la 'change'.
    //  - apoi: ce se adauga la o clasa se ia din ULTIMUL rand (Sol gol / roca), ce
    //    se scade se adauga tot lui; doar cand acela ajunge la 0/100 se urca pe
    //    lista (Plante, Litiera, Muschi). Ordinea randurilor din DOM e deci
    //    semnificativa: ultimul rand e tamponul.
    //  - un rand blocat nu e NICIODATA atins; daca toate celelalte sunt blocate,
    //    randul curent e "inghetat" (nimic de redistribuit).
    // Serverul (SoilDomainService.ensurePercentagesSum100) ramane linia a doua:
    // suma 0 = compozitie neestimata, suma != 100 = eroare.
    function initSoilCompositionSliders() {
        var STEP = 5;
        document.querySelectorAll('[data-soil-composition-group]').forEach(function (group) {
            var inputs = Array.prototype.slice.call(group.querySelectorAll('[data-soil-composition-input]'));
            if (inputs.length < 2) return;
            var count = inputs.length;
            var lockButtons = Array.prototype.slice.call(group.querySelectorAll('[data-soil-composition-lock]'));
            var locked = inputs.map(function () { return false; });

            function valueOf(input) {
                var n = Number(input.value);
                return isNaN(n) ? 0 : n;
            }
            function sumOf(arr) {
                return arr.reduce(function (sum, v) { return sum + v; }, 0);
            }

            // stare "oficiala" a valorilor - sursa de adevar intre interactiuni;
            // input-urile se sincronizeaza mereu din ea (inclusiv sliderul tras,
            // corectat inapoi daca a lovit o limita)
            var values = inputs.map(valueOf);
            // re-randare dupa o eroare de validare: valorile trimise (suma 100)
            // inseamna o compozitie deja estimata, nu o pornire goala
            var primed = sumOf(values) === 100;
            var primingIndex = -1;

            function otherIndexes(index) {
                return inputs.map(function (_, i) { return i; }).filter(function (i) { return i !== index; });
            }

            // prima atingere: restul pana la 100 impartit egal intre celelalte
            function prime(index, newVal) {
                primed = true;
                primingIndex = index;
                values[index] = newVal;
                var others = otherIndexes(index);
                var units = (100 - newVal) / STEP;
                var base = Math.floor(units / others.length);
                var extra = units % others.length;
                others.forEach(function (j, k) {
                    values[j] = (base + (k < extra ? 1 : 0)) * STEP;
                });
            }

            // "Sol gol preia": candidatii neblocati, de la ULTIMUL rand in sus
            function redistribute(index, newVal) {
                var candidates = otherIndexes(index).filter(function (j) { return !locked[j]; }).reverse();
                var delta = newVal - values[index];
                if (delta === 0 || candidates.length === 0) return;
                var capacity = sumOf(candidates.map(function (j) { return delta > 0 ? values[j] : 100 - values[j]; }));
                var amount = Math.min(Math.abs(delta), capacity);
                values[index] += delta > 0 ? amount : -amount;
                var remaining = amount;
                candidates.forEach(function (j) {
                    if (remaining === 0) return;
                    var room = delta > 0 ? values[j] : 100 - values[j];
                    var moved = Math.min(room, remaining);
                    values[j] += delta > 0 ? -moved : moved;
                    remaining -= moved;
                });
            }

            function syncInputsFromValues() {
                inputs.forEach(function (input, i) { input.value = values[i]; });
            }

            function updateDisplay() {
                inputs.forEach(function (input, i) {
                    var row = input.closest('.soil-composition-row');
                    var valueEl = row && row.querySelector('[data-soil-composition-value]');
                    if (valueEl) valueEl.textContent = primed ? values[i] + '%' : '–';
                    var frozen = primed && !locked[i] && otherIndexes(i).every(function (j) { return locked[j]; });
                    input.classList.toggle('is-locked', locked[i]);
                    input.classList.toggle('is-frozen', frozen);
                    input.tabIndex = (locked[i] || frozen) ? -1 : 0;
                });
                lockButtons.forEach(function (btn) { btn.disabled = !primed; });
                var totalEl = group.querySelector('[data-soil-composition-total]');
                if (totalEl) totalEl.classList.toggle('is-empty', !primed);
                var totalIcon = group.querySelector('[data-soil-composition-total-icon]');
                if (totalIcon) totalIcon.className = 'bi ' + (primed ? 'bi-check-circle-fill' : 'bi-circle');
                var totalValueEl = group.querySelector('[data-soil-composition-total-value]');
                if (totalValueEl) totalValueEl.textContent = sumOf(values);
            }

            inputs.forEach(function (input, index) {
                input.addEventListener('input', function () {
                    if (locked[index]) return; // sliderul blocat e si pointer-events:none, dar dubla verificare nu strica
                    if (!primed || primingIndex === index) {
                        prime(index, valueOf(input));
                    } else {
                        redistribute(index, valueOf(input));
                    }
                    syncInputsFromValues();
                    updateDisplay();
                });
                // 'change' = sfarsitul tragerii (degetul/mouse-ul ridicat, sau un
                // pas de tastatura) - de-aici incolo se aplica regula normala
                input.addEventListener('change', function () {
                    if (primingIndex === index) primingIndex = -1;
                });
            });

            lockButtons.forEach(function (btn, index) {
                btn.addEventListener('click', function () {
                    locked[index] = !locked[index];
                    btn.classList.toggle('active', locked[index]);
                    var icon = btn.querySelector('i');
                    if (icon) icon.className = locked[index] ? 'bi bi-lock-fill' : 'bi bi-unlock';
                    var label = locked[index] ? btn.dataset.unlockLabel : btn.dataset.lockLabel;
                    if (label) {
                        btn.title = label;
                        btn.setAttribute('aria-label', label);
                    }
                    updateDisplay();
                });
            });

            updateDisplay();
        });
    }
    initSoilCompositionSliders();

    // Graficele din Statistici publice (statistics/index.html, spec §3) - Chart
    // e definit doar pe ACEASTA pagina (script chart.js incarcat direct in
    // head-ul ei, vezi statistics/index.html), deci functia e un no-op sigur pe
    // orice alta pagina (nici Chart, nici canvas-urile nu exista acolo).
    function initStatisticsCharts() {
        if (typeof Chart === 'undefined') return;

        function readChartData(sourceId) {
            var source = document.getElementById(sourceId);
            if (!source) return null;
            var points = Array.prototype.slice.call(source.querySelectorAll('[data-label]'));
            if (!points.length) return null;
            var rootStyle = getComputedStyle(document.documentElement);
            return {
                labels: points.map(function (el) { return el.getAttribute('data-label'); }),
                values: points.map(function (el) { return Number(el.getAttribute('data-value')) || 0; }),
                // culorile sunt proprietati CSS custom (--chart-role-*/--chart-stage-*,
                // generate din hartile Sass $statistics-role-colors/$phenology-stage-colors,
                // vezi main.scss) - un singur loc de intretinut pt culori, citit aici
                colors: points.map(function (el) {
                    var value = rootStyle.getPropertyValue(el.getAttribute('data-color-var')).trim();
                    return value || 'var(--bs-primary)';
                })
            };
        }

        function renderBarChart(canvasId) {
            var canvas = document.getElementById(canvasId);
            if (!canvas) return;
            var data = readChartData(canvas.getAttribute('data-chart-source'));
            if (!data) return;

            var rootStyle = getComputedStyle(document.documentElement);
            var axisColor = rootStyle.getPropertyValue('--bs-secondary-color').trim() || '#6c757d';
            var gridColor = rootStyle.getPropertyValue('--bs-border-color').trim() || '#dee2e6';

            // eticheta axei X pe 2 randuri (nume + numar), nu doar in tooltip la
            // hover - un array de string-uri pe un tick de categorie e randat
            // nativ de Chart.js pe randuri separate, fara plugin suplimentar
            var labelsWithValue = data.labels.map(function (label, i) {
                return [label, String(data.values[i])];
            });

            new Chart(canvas.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: labelsWithValue,
                    datasets: [{
                        data: data.values,
                        backgroundColor: data.colors,
                        borderRadius: 4,
                        maxBarThickness: 48
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    // un singur dataset (numarul de observatii), identitatea fiecarei
                    // bare vine deja din eticheta axei - un legend separat ar repeta
                    // aceeasi informatie fara sa adauge nimic (regula skill-ului dataviz:
                    // legend obligatoriu doar de la 2+ serii)
                    plugins: {
                        legend: { display: false },
                        // titlul implicit al tooltip-ului foloseste eticheta INTREAGA (array
                        // [nume, valoare], randata pe 2 linii sub bara) - fara suprascriere,
                        // valoarea ar aparea de 2 ori: o data in titlu (din array), o data in
                        // corpul tooltip-ului (din dataset). Titlul retine doar primul rand.
                        tooltip: {
                            callbacks: {
                                title: function (items) {
                                    var label = items[0].chart.data.labels[items[0].dataIndex];
                                    return Array.isArray(label) ? label[0] : label;
                                }
                            }
                        }
                    },
                    scales: {
                        x: { grid: { display: false }, ticks: { color: axisColor } },
                        y: { beginAtZero: true, ticks: { precision: 0, color: axisColor }, grid: { color: gridColor } }
                    }
                }
            });
        }

        function renderStackedBar(canvasId) {
            var canvas = document.getElementById(canvasId);
            if (!canvas) return;
            var data = readChartData(canvas.getAttribute('data-chart-source'));
            if (!data) return;

            var rootStyle = getComputedStyle(document.documentElement);
            var axisColor = rootStyle.getPropertyValue('--bs-secondary-color').trim() || '#6c757d';
            var gridColor = rootStyle.getPropertyValue('--bs-border-color').trim() || '#dee2e6';

            // o singura bara (compozitia medie) - fiecare segment (Muschi/
            // Litiera/Sol gol) e un dataset separat de lungime 1, stivuit pe
            // aceeasi categorie, nu bare multiple ca la renderBarChart de mai
            // sus - vezi skill-ul dataviz (part-to-whole -> stacked bar)
            var datasets = data.labels.map(function (label, i) {
                return {
                    label: label,
                    data: [data.values[i]],
                    backgroundColor: data.colors[i],
                    borderRadius: 4,
                    borderSkipped: false
                };
            });

            new Chart(canvas.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: [''],
                    datasets: datasets
                },
                options: {
                    indexAxis: 'y',
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        // 3 segmente = identitate, nu magnitudine simpla - legenda
                        // e obligatorie de la 2+ serii (skill-ul dataviz); procentul
                        // e afisat direct in eticheta legendei, fiindca un segment
                        // interior de stacked bar nu are capat liber pt o eticheta
                        // inline (vezi marks-and-anatomy.md)
                        legend: {
                            display: true,
                            position: 'bottom',
                            labels: {
                                color: axisColor,
                                generateLabels: function (chart) {
                                    return chart.data.datasets.map(function (ds, i) {
                                        return {
                                            text: ds.label + ' ' + Math.round(ds.data[0]) + '%',
                                            fillStyle: ds.backgroundColor,
                                            strokeStyle: ds.backgroundColor,
                                            datasetIndex: i
                                        };
                                    });
                                }
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: function (item) {
                                    return item.dataset.label + ': ' + item.parsed.x.toFixed(1) + '%';
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            beginAtZero: true,
                            max: 100,
                            grid: { color: gridColor },
                            ticks: { color: axisColor, callback: function (v) { return v + '%'; } }
                        },
                        y: {
                            stacked: true,
                            grid: { display: false },
                            ticks: { display: false }
                        }
                    }
                }
            });
        }

        renderBarChart('statisticsRoleChart');
        renderBarChart('statisticsStageChart');
        renderBarChart('statisticsSeverityChart');
        renderStackedBar('statisticsSoilCompositionChart');
    }
    initStatisticsCharts();

    var loadingOverlayEl = document.getElementById('loading-overlay');
    var loadingOverlayTextEl = document.getElementById('loading-overlay-text');
    var loadingOverlayDefaultText = loadingOverlayTextEl ? loadingOverlayTextEl.textContent : '';
    var loadingShowTimer = null;
    var loadingSafetyTimer = null;
    var loadingActiveCount = 0;

    // message opțional — text diferit pt overlay (ex. "Se determină geolocația"
    // cât timp initGeolocationCapture așteaptă poziția GPS, ÎNAINTE de request-ul
    // multipart real); implicit (fără parametru) revine la textul standard
    // "Vă rugăm să așteptați". Textul se actualizează necondiționat, la FIECARE
    // apel — nu doar când overlay-ul tocmai devine vizibil — fiindcă overlay-ul
    // poate rămâne vizibil neîntrerupt peste 2 faze succesive (GPS → upload),
    // fiecare cu propriul beginLoading(), iar early-return-ul de mai jos (overlay
    // deja vizibil) nu trebuie să blocheze și actualizarea textului.
    function beginLoading(message) {
        loadingActiveCount++;
        if (loadingOverlayTextEl) loadingOverlayTextEl.textContent = message || loadingOverlayDefaultText;
        if (loadingSafetyTimer) clearTimeout(loadingSafetyTimer);
        // 60s, nu 15s - formularele de observatii de teren pot trimite mai multe
        // poze acumulate intr-un singur request multipart, care poate dura mult
        // pe o conexiune mobila lenta; timer-ul asta e doar o plasa de siguranta
        // (ascunde overlay-ul daca ceva ramane blocat), nu un timeout real al
        // request-ului - navigarea reala a browserului nu e afectata de el.
        loadingSafetyTimer = setTimeout(function () {
            endLoading(true);
            // Avertisment GENERIC - STRICT aici, in callback-ul timer-ului, nu in
            // endLoading() insusi: endLoading(true) mai e apelat explicit si din
            // alte locuri (eroare GPS, ramura offline din attemptGeolocationCapture
            // etc.), unde userul stie deja ce s-a intamplat - un toast suplimentar
            // acolo ar fi redundant/gresit. Aici insa chiar nu stim ce s-a
            // intamplat (orice actiune care porneste overlay-ul global poate
            // ajunge sa expire acest timer - click pe link, submit, cerere htmx,
            // download), de-aia mesajul e generic, nu specific unui formular.
            showSlowOperationToast();
        }, 60000);
        if (loadingShowTimer || (loadingOverlayEl && loadingOverlayEl.classList.contains('loading-overlay-visible'))) return;
        loadingShowTimer = setTimeout(function () {
            loadingShowTimer = null;
            if (loadingOverlayEl) loadingOverlayEl.classList.add('loading-overlay-visible');
        }, 200);
    }

    function endLoading(force) {
        loadingActiveCount = force ? 0 : Math.max(0, loadingActiveCount - 1);
        if (loadingActiveCount > 0) return;
        if (loadingShowTimer) {
            clearTimeout(loadingShowTimer);
            loadingShowTimer = null;
        }
        if (loadingSafetyTimer) {
            clearTimeout(loadingSafetyTimer);
            loadingSafetyTimer = null;
        }
        if (loadingOverlayEl) loadingOverlayEl.classList.remove('loading-overlay-visible');
        if (loadingOverlayTextEl) loadingOverlayTextEl.textContent = loadingOverlayDefaultText;
    }

    // Toast generic "operatia dureaza mai mult decat de obicei" - apelat STRICT
    // din callback-ul lui loadingSafetyTimer de mai sus (vezi comentariul de-acolo).
    // #slow-operation-toast (fragments/toast-container.html) - separat de
    // #offline-error-toast (fragments/offline-banner.html, folosit la plasa de
    // siguranta specifica formularelor de teren), fiindca acesta e cu adevarat
    // general, nu legat de contextul offline/coada. Absent pe login-layout.html
    // (nu include toast-container.html) - no-op sigur acolo, la fel ca restul
    // functiilor de toast cu guard pe element lipsa.
    function showSlowOperationToast() {
        var toastEl = document.getElementById('slow-operation-toast');
        var bodyEl = document.getElementById('slow-operation-toast-body');
        if (!toastEl || !bodyEl) return;
        bodyEl.textContent = document.body.dataset.loadingSlowWarning || '';
        new bootstrap.Toast(toastEl).show();
    }

    // htmx declanșează htmx:afterRequest exact o dată per cerere, atât la succes cât și la eșec
    // (vezi documentația htmx) — suficient ca să oprim loader-ul, fără dublă-decrementare.
    // data-no-loading (același atribut folosit deja de listener-ele generice de click/submit
    // de mai jos) e respectat și aici — interacțiuni gândite să rămână "pe loc", fără nicio
    // senzație de navigare (ex. editarea in-place din listă, vezi user/edit.html), nu trebuie
    // să declanșeze overlay-ul de încărcare pe tot ecranul, chiar dacă cererea durează >200ms.
    document.body.addEventListener('htmx:beforeRequest', function (evt) {
        var elt = evt.detail && evt.detail.elt;
        if (elt && elt.closest && elt.closest('[data-no-loading]')) return;
        beginLoading();
    });
    document.body.addEventListener('htmx:afterRequest', function () {
        endLoading();
    });

    var HX_TRIGGER_SELECTOR = '[hx-get],[hx-post],[hx-put],[hx-delete],[hx-patch]';

    function isPlainLeftClick(evt) {
        return evt.button === 0 && !evt.metaKey && !evt.ctrlKey && !evt.shiftKey && !evt.altKey;
    }

    // Descarca prin fetch, NU prin navigarea directa a link-ului — necesar pt
    // orice link cu Content-Disposition: attachment (fortat sa descarce
    // fisierul, fara nicio navigare/unload real al paginii curente de care sa
    // se lege un eveniment de finalizare). Overlay-ul global ramane vizibil pe
    // toata durata REALA a descarcarii (pana cand corpul raspunsului a fost
    // primit integral, response.blob()), nu doar "pana la urmatorul eveniment
    // de navigare" (care nu exista aici) — fara asta, overlay-ul ramanea
    // blocat pe ecran pana la timeout-ul de siguranta de 60s (bug real, gasit
    // la butonul "Export" din observation/list.html, primul link de download
    // fortat din aplicatie). La eroare (retea, sesiune expirata -> raspuns
    // text/html in loc de fisierul real etc.), revine la o navigare directa
    // normala a link-ului — acelasi comportament ca inainte de acest fix,
    // browserul gestioneaza singur eroarea/redirectul (ex. catre /login?expired).
    function downloadViaFetch(link) {
        var url = link.href;
        beginLoading();
        fetch(url, { credentials: 'same-origin' })
            .then(function (response) {
                var contentType = response.headers.get('Content-Type') || '';
                if (!response.ok || contentType.indexOf('text/html') === 0) {
                    throw new Error('unexpected response');
                }
                var disposition = response.headers.get('Content-Disposition') || '';
                var match = /filename="?([^";]+)"?/i.exec(disposition);
                var filename = match ? match[1] : (link.getAttribute('download') || 'download');
                return response.blob().then(function (blob) {
                    return { blob: blob, filename: filename };
                });
            })
            .then(function (result) {
                var objectUrl = URL.createObjectURL(result.blob);
                // NEATASAT la document — daca link-ul sintetic ar fi in DOM,
                // click()-ul lui ar bubble pana la listener-ul global de click
                // de mai jos, care l-ar recunoaste (are si el atributul
                // "download") si ar porni un downloadViaFetch() RECURSIV pe
                // propriul url blob:, blocandu-i in acelasi timp actiunea
                // nativa de salvare (preventDefault) — bug real gasit prin
                // testare (Playwright + console.log), nu presupus: descarcarea
                // nu se declansa niciodata, iar overlay-ul ramanea agatat.
                // Un <a> neatasat la document declanseaza descarcarea nativa
                // la fel de bine, fara sa mai existe niciun eveniment care sa
                // bubble spre acest listener.
                var tempLink = document.createElement('a');
                tempLink.href = objectUrl;
                tempLink.download = result.filename;
                tempLink.click();
                setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
            })
            .catch(function () {
                window.location = url;
            })
            .finally(function () {
                endLoading();
            });
    }

    document.addEventListener('click', function (evt) {
        if (evt.defaultPrevented || !isPlainLeftClick(evt) || !(evt.target instanceof Element)) return;
        var link = evt.target.closest('a[href]');
        if (!link) return;
        if (link.closest(HX_TRIGGER_SELECTOR) || link.hasAttribute('data-bs-toggle') || link.hasAttribute('data-no-loading')) return;
        if (link.target && link.target !== '_self') return;
        if (link.hasAttribute('download')) {
            evt.preventDefault();
            downloadViaFetch(link);
            return;
        }
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
        if (link.origin !== window.location.origin) return;
        beginLoading();
    }, true);

    document.addEventListener('submit', function (evt) {
        var form = evt.target;
        if (evt.defaultPrevented || !(form instanceof HTMLFormElement)) return;
        if (form.closest(HX_TRIGGER_SELECTOR) || form.hasAttribute('data-no-loading')) return;
        if (form.target && form.target !== '_self') return;
        beginLoading();
    }, true);

    // -- Coada offline de observatii (Fenologie/Perturbari/Sol) ----------------
    // Infrastructura IndexedDB pentru introducerea observatiilor fara conexiune
    // la retea. Un singur object store generic (`pendingObservations`), suficient
    // pentru toate 3 module - schema formularelor difera doar la campurile
    // specifice modulului, transportate ca obiect plat `fields`, fara nevoie de
    // store-uri separate per modul. Integrarea efectiva cu formularele (scriere
    // la submit offline, sincronizare la revenirea conexiunii) se adauga separat
    // - acest bloc expune doar operatiile CRUD de baza pe coada, prin
    // window.CaliOffline, testabile independent (vezi frontend/CLAUDE.md).
    var OFFLINE_DB_NAME = 'cali-offline-queue';
    var OFFLINE_DB_VERSION = 1;
    var OFFLINE_STORE_NAME = 'pendingObservations';
    var OFFLINE_QUEUE_MAX_SIZE = 50;
    var offlineDbPromise = null;

    function openOfflineDb() {
        if (!('indexedDB' in window)) {
            return Promise.reject(new Error('IndexedDB nu este disponibil în acest browser'));
        }
        if (offlineDbPromise) return offlineDbPromise;

        offlineDbPromise = new Promise(function (resolve, reject) {
            var request = indexedDB.open(OFFLINE_DB_NAME, OFFLINE_DB_VERSION);
            request.onupgradeneeded = function () {
                var db = request.result;
                if (!db.objectStoreNames.contains(OFFLINE_STORE_NAME)) {
                    var store = db.createObjectStore(OFFLINE_STORE_NAME, { keyPath: 'clientId' });
                    store.createIndex('createdAt', 'createdAt', { unique: false });
                }
            };
            request.onsuccess = function () { resolve(request.result); };
            request.onerror = function () { reject(request.error); };
        });
        return offlineDbPromise;
    }

    // Infasoara o tranzactie IndexedDB (API bazat pe evenimente) intr-un singur
    // Promise - callback-ul primeste store-ul si intoarce el insusi un Promise
    // (de regula infasurand un singur IDBRequest); rezolvarea finala asteapta
    // mereu `tx.oncomplete`, nu doar succesul cererii individuale, ca eventuale
    // erori de commit ale tranzactiei sa nu treaca neobservate.
    function withOfflineStore(mode, callback) {
        return openOfflineDb().then(function (db) {
            return new Promise(function (resolve, reject) {
                var tx = db.transaction(OFFLINE_STORE_NAME, mode);
                var store = tx.objectStore(OFFLINE_STORE_NAME);
                var result;
                tx.oncomplete = function () { resolve(result); };
                tx.onerror = function () { reject(tx.error); };
                tx.onabort = function () { reject(tx.error); };
                Promise.resolve(callback(store)).then(function (value) {
                    result = value;
                }, reject);
            });
        });
    }

    function countPendingObservations() {
        return withOfflineStore('readonly', function (store) {
            return new Promise(function (resolve, reject) {
                var req = store.count();
                req.onsuccess = function () { resolve(req.result); };
                req.onerror = function () { reject(req.error); };
            });
        });
    }

    // Sortate FIFO (createdAt crescator) prin indexul dedicat - ordinea de
    // afisare in banner si de sincronizare (vezi syncQueue, adaugat separat)
    // trebuie sa fie identica.
    function getPendingObservations() {
        return withOfflineStore('readonly', function (store) {
            return new Promise(function (resolve, reject) {
                var results = [];
                var index = store.index('createdAt');
                var req = index.openCursor();
                req.onsuccess = function () {
                    var cursor = req.result;
                    if (cursor) {
                        results.push(cursor.value);
                        cursor.continue();
                    } else {
                        resolve(results);
                    }
                };
                req.onerror = function () { reject(req.error); };
            });
        });
    }

    // Plafonul (mockup: "Maxim 50 observatii in coada") e verificat la SCRIERE,
    // nu la citire - daca e atins, scrierea esueaza explicit (eroare cu
    // err.code='QUEUE_FULL'), formularul completat de user ramane needitat, ca
    // sa poata sterge un item existent sau astepta sincronizarea inainte de a
    // reincerca.
    function addPendingObservation(record) {
        return countPendingObservations().then(function (count) {
            if (count >= OFFLINE_QUEUE_MAX_SIZE) {
                var err = new Error('Coada offline este plină (maxim ' + OFFLINE_QUEUE_MAX_SIZE + ' observații)');
                err.code = 'QUEUE_FULL';
                throw err;
            }
            return withOfflineStore('readwrite', function (store) {
                return new Promise(function (resolve, reject) {
                    var req = store.add(record);
                    req.onsuccess = function () { resolve(record); };
                    req.onerror = function () { reject(req.error); };
                });
            });
        });
    }

    // Folosit la sincronizare (syncQueue) pt marcarea status-ului unui item
    // existent (ex. 'SYNCING'/'FAILED') fara sa treaca prin verificarea de
    // plafon din addPendingObservation - itemul exista deja in coada.
    function updatePendingObservation(record) {
        return withOfflineStore('readwrite', function (store) {
            return new Promise(function (resolve, reject) {
                var req = store.put(record);
                req.onsuccess = function () { resolve(record); };
                req.onerror = function () { reject(req.error); };
            });
        });
    }

    function deletePendingObservation(clientId) {
        return withOfflineStore('readwrite', function (store) {
            return new Promise(function (resolve, reject) {
                var req = store.delete(clientId);
                req.onsuccess = function () { resolve(); };
                req.onerror = function () { reject(req.error); };
            });
        });
    }

    // Index local, per modul, STRICT pentru afisare in banner (ex. "Phenology
    // #15") - NU e cod de referinta real (acela se genereaza doar server-side,
    // dupa saveAndFlush, vezi CLAUDE.md radacina - nu poate fi calculat offline).
    // Persistat separat in localStorage (nu in IndexedDB, nu in recordul din
    // coada), ca sa continue sa creasca chiar si dupa ce un item e sters din
    // coada (sincronizat cu succes sau eliminat manual).
    function nextLocalIndex(moduleType) {
        var key = 'cali-offline-local-index-' + moduleType;
        var current = parseInt(window.localStorage.getItem(key), 10);
        if (isNaN(current)) current = 0;
        var next = current + 1;
        window.localStorage.setItem(key, String(next));
        return next;
    }

    window.CaliOffline = {
        MAX_QUEUE_SIZE: OFFLINE_QUEUE_MAX_SIZE,
        openDb: openOfflineDb,
        count: countPendingObservations,
        getAll: getPendingObservations,
        add: addPendingObservation,
        update: updatePendingObservation,
        remove: deletePendingObservation,
        nextLocalIndex: nextLocalIndex
    };

    // Prag de toleranta pt un submit ONLINE normal - daca timpul ESTIMAT de
    // upload al pozelor deja atasate (calculat din viteza REALA masurata de
    // proba de mai jos, nu doar "exista conectivitate") depaseste acest
    // prag, preferam sa scriem direct in coada offline in loc sa incercam un
    // submit care ar putea ramane blocat minute intregi, fara nicio cale de
    // a semnala vreodata esecul userului (POST HTML nativ, fara
    // AbortController - vezi scheduleSlowSubmitFallback() mai jos si
    // CLAUDE.md radacina, bug raportat 2026-08-31). Sub loadingSafetyTimer
    // (60s, beginLoading()) cu marja, ca acel timer sa ramana strict o plasa
    // de siguranta rara, nu calea normala de tratare a conexiunilor lente.
    var UPLOAD_TOLERANCE_SECONDS = 45;

    // Timeout-ul probei in sine (nu al submit-ului real) - daca proba insasi
    // nu se termina in acest interval, e deja o dovada suficienta de
    // conexiune prea slaba (sau inexistenta), fara sa mai fie nevoie sa
    // asteptam o valoare exacta de viteza.
    var CONNECTIVITY_PROBE_TIMEOUT_MS = 3000;

    // Insumeaza dimensiunea tuturor pozelor deja atasate pe formular (ambele
    // input-uri, camera+galerie, name="photos" - vezi initAccumulatingFileInputs)
    // - folosit ca sa estimam cat ar dura upload-ul REAL, nu doar cat de
    // repede raspunde serverul la un payload mic de proba.
    // form e OPTIONAL - probeConnectivity() e apelat si fara niciun formular
    // concret, la sincronizarea cozii offline (syncQueue()/maybeSyncQueue(),
    // buton "Sincronizare coada" din /offline-queue), unde nu exista un
    // singur payload de estimat. Fara form, intoarce 0 - estimatedUploadSeconds
    // ajunge automat 0 (mereu sub prag), reducand proba la o simpla verificare
    // de accesibilitate, exact comportamentul dorit acolo.
    function totalAttachedPhotoBytes(form) {
        var total = 0;
        if (!form) return total;
        form.querySelectorAll('input[type="file"]').forEach(function (input) {
            Array.prototype.forEach.call(input.files || [], function (file) { total += file.size; });
        });
        return total;
    }

    // Proba REALA de conectivitate + viteza, folosita inainte de a decide
    // submit direct vs. scriere in coada. navigator.onLine e doar un filtru
    // rapid ieftin (poate raporta true chiar fara conectivitate reala la
    // internet, doar interfata de retea activa), insuficient de sigur
    // singur - dar util ca sa distingem "chiar fara retea" (OFFLINE) de
    // "retea prezenta, dar prea lenta pt pozele atasate" (SLOW), distinctie
    // folosita mai departe doar pt alegerea textului toast-ului de
    // confirmare (vezi queueObservationOffline/showOfflineSavedToast).
    //
    // /connectivity-probe (ConnectivityProbeController, shared/web) intoarce
    // un payload FIX de 50KB, generat o singura data server-side - inlocuieste
    // vechiul HEAD pe favicon.ico, care testa doar accesibilitate (un fisier
    // de cativa KB se termina aproape instant chiar si pe o conexiune prea
    // slaba pt un upload real de poze, deci nu spunea nimic despre viteza).
    // fetch() se rezolva la primirea HEADERELOR raspunsului, nu dupa tot
    // corpul - de-aia citim explicit response.arrayBuffer(), ca timpul
    // masurat sa reflecte transferul complet, nu doar raspunsul initial.
    //
    // Intoarce Promise<'ONLINE'|'SLOW'|'OFFLINE'>.
    function probeConnectivity(form) {
        if (!navigator.onLine) return Promise.resolve('OFFLINE');
        if (typeof APP_BASE_URL === 'undefined') return Promise.resolve('ONLINE');

        var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var timedOut = false;
        var timeoutId = controller ? setTimeout(function () {
            timedOut = true;
            controller.abort();
        }, CONNECTIVITY_PROBE_TIMEOUT_MS) : null;

        var startedAt = Date.now();
        return fetch(APP_BASE_URL + 'connectivity-probe', {
            method: 'GET',
            cache: 'no-store',
            signal: controller ? controller.signal : undefined
        }).then(function (response) {
            if (!response.ok) throw new Error('probe not ok');
            return response.arrayBuffer();
        }).then(function (buffer) {
            if (timeoutId) clearTimeout(timeoutId);
            var elapsedSeconds = Math.max((Date.now() - startedAt) / 1000, 0.001);
            var bytesPerSecond = buffer.byteLength / elapsedSeconds;
            var estimatedUploadSeconds = totalAttachedPhotoBytes(form) / bytesPerSecond;
            return estimatedUploadSeconds > UPLOAD_TOLERANCE_SECONDS ? 'SLOW' : 'ONLINE';
        }).catch(function () {
            if (timeoutId) clearTimeout(timeoutId);
            return timedOut ? 'SLOW' : 'OFFLINE';
        });
    }

    // Extrage campurile scalare (obiect plat, generic - identic pt toate 3
    // module) si pozele reale (File-uri nevide de la name="photos") dintr-un
    // formular de observatie - folosit la scrierea in coada offline.
    // _csrf NU se retine (tokenul curent devine irelevant offline - la
    // sincronizare se cere unul proaspat, vezi syncQueue).
    function extractOfflineFieldsAndPhotos(form) {
        var formData = new FormData(form);
        var fields = {};
        var photos = [];
        formData.forEach(function (value, key) {
            if (key === '_csrf') return;
            if (value instanceof File) {
                if (key === 'photos' && value.size > 0) {
                    photos.push({ name: value.name, type: value.type || 'application/octet-stream', blob: value });
                }
                return;
            }
            if (Object.prototype.hasOwnProperty.call(fields, key)) {
                fields[key] = [].concat(fields[key], value);
            } else {
                fields[key] = value;
            }
        });
        return { fields: fields, photos: photos };
    }

    // reason: 'OFFLINE' (fara conexiune deloc) sau 'SLOW' (conexiune prezenta,
    // dar prea lenta pt pozele atasate, estimat de probeConnectivity()) - text
    // diferit pt fiecare, ca userul sa inteleaga DE CE a fost pusa in coada,
    // nu doar CA a fost pusa (vezi CLAUDE.md radacina, bug raportat 2026-08-31).
    // Implicit 'OFFLINE', pt orice apelant care nu specifica un motiv.
    function showOfflineSavedToast(reason) {
        var toastEl = document.getElementById('offline-saved-toast');
        var bodyEl = document.getElementById('offline-saved-toast-body');
        if (!toastEl || !bodyEl) return;
        bodyEl.textContent = (reason === 'SLOW' ? document.body.dataset.offlineSavedSlow : document.body.dataset.offlineSaved) || '';
        new bootstrap.Toast(toastEl).show();
    }

    // Plasa de siguranta (b) - vezi scheduleSlowSubmitFallback(). Refoloseste
    // acelasi toast rosu generic (#offline-error-toast) ca restul erorilor de
    // coada offline - desi aici nimic nu a fost pus in coada, e acelasi
    // registru vizual "e o problema de care ar trebui sa fiti constient",
    // fara sa introduca o a treia varianta de culoare de toast.
    function showSlowSubmitToast() {
        var toastEl = document.getElementById('offline-error-toast');
        var bodyEl = document.getElementById('offline-error-toast-body');
        if (!toastEl || !bodyEl) return;
        bodyEl.textContent = document.body.dataset.offlineSlowSubmit || '';
        new bootstrap.Toast(toastEl).show();
    }

    function showOfflineErrorToast(err) {
        var toastEl = document.getElementById('offline-error-toast');
        var bodyEl = document.getElementById('offline-error-toast-body');
        if (!toastEl || !bodyEl) return;
        var text = (err && err.code === 'QUEUE_FULL') ? document.body.dataset.offlineFull
            : (err && err.code === 'INCOMPLETE') ? document.body.dataset.offlineIncomplete
            : (err && err.code === 'UNEXPECTED_REDIRECT') ? offlineSyncBlockedMessage(err)
            : (err && err.message);
        bodyEl.textContent = text || document.body.dataset.offlineFull || '';
        new bootstrap.Toast(toastEl).show();
    }

    // Textul de toast pt UNEXPECTED_REDIRECT (vezi isExpectedSyncRedirect mai
    // jos) - distinge cazul CUNOSCUT azi (gate GDPR, mesaj specific si
    // actionabil) de orice alt redirect neasteptat viitor (mesaj generic,
    // fara cod nou necesar la aparitia unui gate similar).
    function offlineSyncBlockedMessage(err) {
        var isGdpr = err.redirectUrl && /\/gdpr-accept(\?|$)/.test(err.redirectUrl);
        return isGdpr
            ? (document.body.dataset.offlineSyncBlockedGdpr || document.body.dataset.offlineSyncBlocked)
            : document.body.dataset.offlineSyncBlocked;
    }

    // Verificare de completitudine INAINTE de scrierea in coada offline - citeste
    // marcaje declarative direct din markup (data-offline-required-any /
    // data-offline-required-if), NU o lista hardcodata per modul in JS (fosta
    // forma, switch pe moduleType - inlocuita 2026-08-13, dupa ce gol-ul deja
    // documentat aici initial - Sol/"Tip insecta" - a fost discutat explicit cu
    // userul). Ramane o oglinda a regulilor reale de pe server (DomainService/
    // Bean Validation) - NU elimina duplicarea, doar o reduce practic: marcajul
    // sta chiar langa campul pe care-l descrie in template, nu intr-un switch
    // separat, usor de uitat la o modificare viitoare a formularului. Adaugarea
    // unui camp obligatoriu nou (orice modul) NU mai cere nicio modificare AICI
    // - doar marcajul potrivit pe elementul din HTML. Respins explicit:
    // required/setCustomValidity nativ HTML - bulele native ale browserului
    // sunt in limba lui de interfata, nu trec prin messages.properties, si nu
    // pot fi stilizate ca restul erorilor din aplicatie (fieldError(), vezi
    // claude-context/templates/CLAUDE.md).
    function isOfflineObservationComplete(form, extracted) {
        if (extracted.photos.length === 0) return false;

        var anyGroupsOk = Array.prototype.every.call(
            form.querySelectorAll('[data-offline-required-any]'),
            function (group) {
                var fieldName = group.dataset.offlineRequiredAny;
                return !!group.querySelector('input[name="' + fieldName + '"]:checked');
            }
        );
        if (!anyGroupsOk) return false;

        // <select> obligatoriu (data-offline-required-select="<name>"): valoarea
        // nu poate fi optiunea goala. Un <select> nu are "input:checked", deci nu
        // poate folosi data-offline-required-any de mai sus (fields/species.html).
        // suma obligatorie (data-offline-required-sum="100" pe grupul de slidere
        // Sol): o compozitie neestimata (pornire goala, suma 0) nu intra in coada
        // offline - ar fi respinsa definitiv la sincronizare
        // (SoilDomainService.ensurePercentagesSum100)
        var sumsOk = Array.prototype.every.call(
            form.querySelectorAll('[data-offline-required-sum]'),
            function (container) {
                var sum = Array.prototype.reduce.call(container.querySelectorAll('input'), function (acc, input) {
                    return acc + (Number(input.value) || 0);
                }, 0);
                return sum === Number(container.dataset.offlineRequiredSum);
            }
        );
        if (!sumsOk) return false;

        var selectsOk = Array.prototype.every.call(
            form.querySelectorAll('[data-offline-required-select]'),
            function (select) { return !!select.value; }
        );
        if (!selectsOk) return false;

        // camp obligatoriu doar pentru o anumita valoare a unui <select>
        // (data-offline-required-if-value="<name>=<VALOARE>") - varianta pentru
        // <select> a lui data-offline-required-if de mai jos, care cere o ancora
        // bifata (checkbox/radio).
        var ifValueOk = Array.prototype.every.call(
            form.querySelectorAll('[data-offline-required-if-value]'),
            function (container) {
                var parts = container.dataset.offlineRequiredIfValue.split('=');
                var anchor = form.querySelector('[name="' + parts[0] + '"]');
                if (!anchor || anchor.value !== parts[1]) return true; // conditia nu e activa
                var field = container.querySelector('input, textarea, select');
                return !!(field && field.value && field.value.trim());
            }
        );
        if (!ifValueOk) return false;

        return Array.prototype.every.call(
            form.querySelectorAll('[data-offline-required-if]'),
            function (container) {
                var anchor = document.getElementById(container.dataset.offlineRequiredIf);
                if (!anchor || !anchor.checked) return true; // conditia nu e activa
                var field = container.querySelector('input, textarea, select');
                return !!(field && field.value && field.value.trim());
            }
        );
    }

    // Scrie o observatie completata offline in coada IndexedDB - apelata din
    // initGeolocationCapture() cand proba de conectivitate esueaza. Formularul
    // NU e resetat manual (ar cere reconstruirea starii interne a preview-ului
    // de poze din initAccumulatingFileInputs, needisponibila din afara acelei
    // closure) - identic cu fluxul online "Salvare si formular nou", pagina se
    // reincarca (servita din cache de service worker chiar si offline, vezi
    // OFFLINE_CAPABLE_NAVIGATIONS din service-worker.js), cu o mica intarziere
    // ca toast-ul de confirmare sa apuce sa fie vazut. Formularul NECOMPLET
    // (vezi isOfflineObservationComplete) NU e scris deloc, NU reincarca
    // pagina - userul ramane pe formularul completat partial, ca sa poata
    // corecta si retrimite, exact ca la o eroare de validare online.
    // reason: 'OFFLINE'|'SLOW' (vezi probeConnectivity()) - transportat doar
    // pana la toast-ul de confirmare (sessionStorage, mai jos), fara sa
    // ajunga pe record-ul IndexedDB insusi (sincronizarea nu are nevoie de el).
    function queueObservationOffline(form, reason) {
        if (!window.CaliOffline) return Promise.reject(new Error('Coada offline indisponibilă'));
        var toastReason = reason || 'OFFLINE';
        var moduleType = form.dataset.moduleType;
        var moduleLabel = form.dataset.moduleLabel || moduleType;
        var extracted = extractOfflineFieldsAndPhotos(form);

        if (!isOfflineObservationComplete(form, extracted)) {
            var incompleteErr = new Error('Formularul nu este complet');
            incompleteErr.code = 'INCOMPLETE';
            return Promise.reject(incompleteErr);
        }

        var record = {
            clientId: (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('offline-' + Date.now() + '-' + Math.random().toString(16).slice(2)),
            moduleType: moduleType,
            moduleLabel: moduleLabel,
            // NU form.action (proprietatea) - e UMBRITA de controlul din
            // formular numit "action" (cele 2 butoane de submit, name="action"),
            // gotcha clasic de named-property pe HTMLFormElement (nume rezervate
            // ca "action"/"submit"/"reset"/"method"): form.action ar intoarce
            // elementul <button>, nu URL-ul, iar record-ul ar deveni neclonabil
            // (DataCloneError la IndexedDB). getAttribute() citeste atributul
            // brut, neumbrit - path relativ la origine (@{/phenology} etc.),
            // suficient pt fetch() la sincronizare (acelasi origin mereu).
            endpoint: form.getAttribute('action'),
            createdAt: Date.now(),
            localIndex: window.CaliOffline.nextLocalIndex(moduleType),
            fields: extracted.fields,
            photos: extracted.photos,
            returnTo: extracted.fields.returnTo || null,
            status: 'PENDING',
            attempts: 0,
            lastError: null
        };

        return window.CaliOffline.add(record).then(function () {
            // Bug real raportat 2026-08-13: showOfflineSavedToast() aici, pe
            // pagina VECHE, aratat doar ~1500ms inainte de reload - mult sub
            // durata reala configurata a toast-ului (9s, vezi
            // fragments/offline-banner.html), care disparea taiat de reload
            // inainte sa apuce cineva sa-l citeasca; in plus, pe pagina noua
            // (dupa reload), avertismentul de conectivitate putea reaparea
            // (offlineWarningDismissed se reseteaza altfel la fiecare incarcare
            // - vezi mai jos) chiar peste locul unde tocmai fusese toast-ul,
            // dand impresia ca "il acopera". Fix: toast-ul NU se mai arata aici
            // - se seteaza doar un flag in sessionStorage, consumat pe pagina
            // NOUA (dupa reload) de initOfflineBanner(), unde ruleaza cu toata
            // durata lui, deja stivuit corect sub avertisment (daca e vizibil).
            try {
                sessionStorage.setItem(OFFLINE_SAVED_TOAST_PENDING_KEY, toastReason);
            } catch (e) {
                // sessionStorage indisponibil (mod privat etc.) - arata macar
                // pe pagina curenta, mai bine decat nimic
                showOfflineSavedToast(toastReason);
            }
            refreshOfflineBanner();
            setTimeout(function () {
                window.location.reload();
            }, 300);
        });
    }

    // -- Banner offline (avertisment de conectivitate + coada de sincronizat) --
    // "o observatie in coada", nu "1 observatie in coada" - la cererea
    // userului, articolul nehotarat suna mai natural in romana; "o" sta acum
    // in mesaj (offline.banner.queueCount.one), nu in JS.
    function formatOfflineQueueCount(n) {
        var d = document.body.dataset;
        return pluralText(n, { one: d.offlineCountOne, few: d.offlineCountFew, other: d.offlineCountOther })
            .replace('{0}', n);
    }

    // Format LUNG romanesc ("12 august 2026 14:30"), acelasi standard folosit
    // peste tot in aplicatie (ui.dateTimeFormatLong, #temporals.format din
    // Thymeleaf) - fara nicio exceptie, inclusiv aici. Intl.DateTimeFormat
    // (nu un array hardcodat de nume de luni) - proiectul foloseste deja
    // functionalitati moderne de browser (ex. selectorul CSS :has()).
    function formatOfflineQueueDateTime(timestamp) {
        var d = new Date(timestamp);
        var datePart = new Intl.DateTimeFormat('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
        var hh = ('0' + d.getHours()).slice(-2);
        var mm = ('0' + d.getMinutes()).slice(-2);
        return datePart + ' ' + hh + ':' + mm;
    }

    var offlineBannerEl = document.getElementById('offline-banner');
    // Elementele paginii dedicate /offline-queue (templates/offlinequeue/index.html)
    // - null pe orice alta pagina, ceea ce ghideaza refreshOfflineBanner() sa
    // sara peste randarea listei complete acolo (vezi mai jos). Pana la
    // 2026-08-13, lista completa a cozii traia in caseta fixa de pe fiecare
    // pagina (#offline-banner-queue-card) - mutata pe pagina proprie dupa ce
    // s-a constatat ca un banner position:fixed caruia i se permite sa creasca
    // "cat are loc" poate acoperi complet formularul de dedesubt, indiferent
    // cat de corect e calculata rezerva (limitare structurala, nu eroare de
    // calcul - vezi CLAUDE.md radacina, sectiunea Offline/PWA). Fara aceasta
    // constrangere de inaltime, pagina noua scroleaza normal - nu mai e nevoie
    // de mecanismul de rezerva masurata/indiciu de scroll de dinainte.
    var offlineQueuePageListEl = document.getElementById('offlinequeue-list');
    // Persistat in sessionStorage, nu doar variabila in-memory - bug real
    // raportat 2026-08-13: queueObservationOffline() face un reload de pagina
    // dupa scriere (vezi mai jos), care reseta silentios variabila la fals,
    // aducand INAPOI avertismentul chiar daca userul il inchisese cu putin
    // timp inainte - pe pagina noua, acest avertisment "reaparut" ajungea sa
    // acopere vizual toast-ul de confirmare aratat imediat dupa el. Reseteaza
    // DOAR la o tranzitie FRESH online->offline (evenimentul 'offline' de mai
    // jos) - un avertisment inchis de user nu trebuie sa ramana ascuns la
    // nesfarsit daca userul revine online si pierde din nou conexiunea mai
    // tarziu, dar NICI sa reapara doar pentru ca pagina s-a reincarcat cat
    // timp userul e tot offline, fara nicio tranzitie reala.
    var OFFLINE_WARNING_DISMISSED_KEY = 'cali-offline-warning-dismissed';
    var offlineWarningDismissed = false;
    try {
        offlineWarningDismissed = sessionStorage.getItem(OFFLINE_WARNING_DISMISSED_KEY) === '1';
    } catch (e) {
        // sessionStorage indisponibil (mod privat etc.) - ramane fals, acelasi
        // comportament ca inainte de acest fix
    }

    // Flag pt toast-ul de "salvat offline" amanat pana pe pagina NOUA (dupa
    // reload-ul din queueObservationOffline()) - vezi comentariul de-acolo.
    var OFFLINE_SAVED_TOAST_PENDING_KEY = 'cali-offline-saved-toast-pending';

    // Ultimul numar cunoscut al cozii, cache-uit optimist - vezi comentariul
    // din updateOfflineQueueNavBadge().
    var OFFLINE_QUEUE_BADGE_COUNT_KEY = 'cali-offline-queue-badge-count';

    // Delegare pe container (nu listener per-item) - lista se reconstruieste
    // integral la fiecare refreshOfflineBanner(), un listener per-<li> ar
    // acumula duplicate. Itemul cu status FAILED (esec de VALIDARE definitiv,
    // vezi syncOneRecord) poate fi sters la fel ca unul PENDING - userul
    // renunta pur si simplu la acea observatie, fara reincercare posibila.
    (function initOfflineQueueRemoveDelegation() {
        var listEl = document.getElementById('offlinequeue-list');
        if (!listEl) return;
        listEl.addEventListener('click', function (evt) {
            var btn = evt.target.closest('[data-offline-remove]');
            if (!btn || !window.CaliOffline) return;
            var clientId = btn.dataset.offlineRemove;
            var label = btn.dataset.offlineRemoveConfirmLabel || '';
            var question = (document.body.dataset.offlineConfirmRemove || '').replace('{0}', label);
            showConfirmModal(question, function () {
                window.CaliOffline.remove(clientId).then(refreshOfflineBanner);
            });
        });
    })();

    // Arata/ascunde intrarea "Coada offline" din navbar (fragments/header.html)
    // + numarul de pe badge - global, ruleaza pe ORICE pagina (spre deosebire
    // de randarea listei complete, care exista doar pe /offline-queue). Ascuns
    // implicit in markup (d-none pe #offlinequeue-nav-item) - aratat aici DOAR
    // cand coada nu e goala, exact ca fosta caseta a cozii pe care o inlocuieste.
    //
    // Bug real raportat de user 2026-09-11 (Perturbari, conexiune slaba): dupa
    // reload-ul din queueObservationOffline(), toast-ul "salvat offline" apare
    // SINCRON (flag din sessionStorage), dar aceasta functie e apelata STRICT
    // din .then()-ul asincron al refreshOfflineBanner() -> CaliOffline.getAll()
    // (IndexedDB) - exista deci o fereastra (uneori vizibila, mai ales dupa un
    // reload servit prin fallback-ul network-first al Service Worker-ului pe o
    // conexiune slaba) in care badge-ul e inca ascuns desi coada nu e goala.
    // Fix: valoarea e cache-uita optimist in localStorage la fiecare apel
    // reusit - initOfflineBanner() o aplica SINCRON la incarcarea paginii,
    // inainte sa astepte raspunsul IndexedDB, exact acelasi tipar deja folosit
    // la OFFLINE_SAVED_TOAST_PENDING_KEY (valoare optimista aplicata imediat,
    // corectata ulterior de sursa autoritativa - refreshOfflineBanner() insusi,
    // needitat ca logica).
    function updateOfflineQueueNavBadge(count) {
        var navItemEl = document.getElementById('offlinequeue-nav-item');
        var badgeEl = document.getElementById('offlinequeue-nav-badge');
        if (navItemEl) navItemEl.classList.toggle('d-none', count === 0);
        if (badgeEl) badgeEl.textContent = count > 0 ? String(count) : '';
        try {
            localStorage.setItem(OFFLINE_QUEUE_BADGE_COUNT_KEY, String(count));
        } catch (e) {
            // localStorage indisponibil (mod privat etc.) - fara cache optimist
            // de aplicat la urmatoarea incarcare, badge-ul ramane doar pe calea
            // asincrona normala, ca inainte de acest fix
        }
    }

    // Coada offline e legata de BROWSER (IndexedDB per-origine), NU de contul
    // autentificat - un Admin (fara drept de creare observatii, SecurityConfig)
    // logat pe acelasi device dupa un alt user poate vedea coada acelui user,
    // desi n-are cum sa fi creat-o el insusi. canCreateObservations e acelasi
    // atribut global deja folosit de offline.html (layouts/layout.html) - citit
    // LIVE din pagina curenta, nu cache-uit separat aici, ca sa reflecte
    // intotdeauna contul CURENT logat (self-corecteaza automat la un login cu
    // alt cont, fara nicio logica de "reactivare" separata).
    function canCurrentUserCreateObservations() {
        return document.body.dataset.canCreateObservations === 'true';
    }

    // Randarea listei complete + starea goala/butonul de sincronizare - DOAR pe
    // pagina dedicata /offline-queue (offlineQueuePageListEl fiind null pe
    // orice alta pagina, functia nu face nimic acolo, apelata totusi din
    // acelasi refreshOfflineBanner() global, fara alt punct de declansare).
    function renderOfflineQueuePage(records) {
        var listEl = offlineQueuePageListEl;
        var emptyEl = document.getElementById('offlinequeue-empty');
        var cardEl = document.getElementById('offlinequeue-card');
        var syncBtn = document.getElementById('offlinequeue-sync-btn');
        var syncWrapEl = document.getElementById('offlinequeue-sync-wrap');
        var noRightsEl = document.getElementById('offlinequeue-no-rights-notice');
        var showQueue = records.length > 0;
        var canCreate = canCurrentUserCreateObservations();

        if (emptyEl) emptyEl.classList.toggle('d-none', showQueue);
        if (cardEl) cardEl.classList.toggle('d-none', !showQueue);
        // Notita + dezactivarea sincronizarii de mai jos au sens DOAR cand
        // coada chiar contine ceva ce acest cont nu poate gestiona - o coada
        // goala nu are nimic de explicat, indiferent de rol.
        if (noRightsEl) noRightsEl.classList.toggle('d-none', !showQueue || canCreate);
        if (syncBtn) syncBtn.disabled = offlineSyncInProgress || !canCreate;
        if (syncWrapEl) {
            syncWrapEl.classList.toggle('has-tooltip-hint', !canCreate);
            if (canCreate) {
                syncWrapEl.removeAttribute('title');
            } else {
                syncWrapEl.setAttribute('title', document.body.dataset.offlineQueueSyncNoRightsTooltip || '');
            }
        }
        if (!showQueue) return;

        var countEl = document.getElementById('offlinequeue-count');
        if (countEl) {
            // cat timp syncQueue() ruleaza, textul arata progresul in loc
            // de numarul static al cozii - reflecta implicit fiecare item
            // procesat, fiindca refreshOfflineBanner() e apelat dupa
            // fiecare rezultat individual din reduce() (vezi syncQueue)
            countEl.textContent = offlineSyncInProgress
                ? (document.body.dataset.offlineSyncing || '') + ' (' + records.length + ')'
                : formatOfflineQueueCount(records.length);
        }

        listEl.innerHTML = '';
        records.forEach(function (record) {
            var li = document.createElement('li');

            // 2 randuri, nu un singur text concatenat pe un rand - eticheta
            // modulului+index (scurta, fara risc de latime) pe primul rand,
            // data+ora completa (format lung) pe al doilea.
            var textWrap = document.createElement('div');

            var line1 = document.createElement('div');
            line1.textContent = (record.moduleLabel || record.moduleType) + ' #' + record.localIndex;

            var line2 = document.createElement('div');
            line2.className = record.status === 'FAILED' ? 'small text-danger' : 'small text-muted';
            line2.textContent = formatOfflineQueueDateTime(record.createdAt);

            if (record.status === 'FAILED') line1.classList.add('text-danger');

            textWrap.appendChild(line1);
            textWrap.appendChild(line2);

            // Explicatie vizibila PERMANENT (nu doar un toast trecator, care
            // userul poate rata sau care oricum nu mai e pe ecran cand
            // revine sa verifice coada mai tarziu) pt itemele FAILED - bug
            // real raportat 2026-08-12: userul vedea doar data cu rosu, fara
            // niciun indiciu ce s-a intamplat sau ce sa faca. 2 coduri posibile
            // azi (record.lastError, vezi syncOneRecord): 'VALIDATION' (eroare
            // de domeniu, server intoarce formularul re-randat) si
            // 'FILE_TOO_LARGE' (poza peste limita serverului, prinsa de plasa
            // de siguranta ÎNAINTE de fetch - vezi syncOneRecord) - fiecare cu
            // textul lui propriu; daca apare vreodata un al treilea cod,
            // mapeaza-l la fel aici, nu reutiliza orbeste unul din cele 2.
            if (record.status === 'FAILED') {
                var line3 = document.createElement('div');
                line3.className = 'small text-danger mt-1';
                line3.textContent = record.lastError === 'FILE_TOO_LARGE'
                    ? (document.body.dataset.offlineErrorFileTooLarge || '').replace('{0}', STORAGE_MAX_FILE_SIZE_MB)
                    : (document.body.dataset.offlineErrorValidation || '');
                textWrap.appendChild(line3);
            }

            li.appendChild(textWrap);

            if (!offlineSyncInProgress && canCreate) {
                // bi-trash-fill (nu .btn-close/X) - acel X semnaliza vizual
                // "inchide un mesaj", desi actiunea reala e o stergere
                // ireversibila a observatiei+pozelor din IndexedDB (sesizare
                // reala a userului 2026-08-12); confirmarea (vezi
                // initOfflineQueueRemoveDelegation) foloseste eticheta de
                // mai jos ca sa identifice exact itemul in intrebare.
                var removeBtn = document.createElement('button');
                removeBtn.type = 'button';
                removeBtn.className = 'btn btn-link text-danger p-0 border-0 offlinequeue-item-remove';
                removeBtn.setAttribute('data-offline-remove', record.clientId);
                removeBtn.setAttribute('data-offline-remove-confirm-label', line1.textContent);
                removeBtn.setAttribute('aria-label', document.body.dataset.offlineRemoveLabel || '');
                removeBtn.innerHTML = '<i class="bi bi-trash-fill" aria-hidden="true"></i>';
                li.appendChild(removeBtn);
            }

            listEl.appendChild(li);
        });
    }

    function refreshOfflineBanner() {
        if (!offlineBannerEl || !window.CaliOffline) return;
        // overlay-ul de eroare GPS suprapunea vizual bannerul (iconita lui
        // disparea complet sub avertisment) - decizie explicita a userului,
        // dupa comparatie vizuala: avertismentul de conectivitate se ascunde
        // complet cat timp overlay-ul e activ, reapare la inchiderea lui
        // (hideGeoErrorOverlay). Badge-ul din navbar si pagina /offline-queue
        // NU se suprapun cu overlay-ul (element separat), raman neatinse.
        // #offline-banner insusi NU se mai togleaza d-none (poate contine si
        // toast-uri de salvare/eroare care trebuie sa ramana vizibile
        // independent de starea avertismentului - vezi comentariul din
        // fragments/offline-banner.html) - doar alert-ul, individual.
        var alertEl = offlineBannerEl.querySelector('.alert');
        var showWarning = !geoErrorOverlayActive && !navigator.onLine && !offlineWarningDismissed;
        if (alertEl) alertEl.classList.toggle('d-none', !showWarning);

        window.CaliOffline.getAll().then(function (records) {
            updateOfflineQueueNavBadge(records.length);
            if (offlineQueuePageListEl) renderOfflineQueuePage(records);
        }).catch(function (err) {
            // Nu lasa badge-ul "orfan" fara nicio urma - vezi comentariul din
            // updateOfflineQueueNavBadge() pt istoricul bug-ului. Starea
            // optimista deja aplicata (cache localStorage, la bootstrap) ramane
            // neatinsa - nu o suprascriem cu o stare goala doar fiindca citirea
            // autoritativa a esuat de data asta.
            console.error('[CaliOffline] refreshOfflineBanner: getAll() a esuat', err);
        });
    }

    // Elementele specifice paginii /offline-queue (text "Maxim N" + butonul de
    // sincronizare) - separat de initOfflineBanner() (global), guardat pe
    // offlineQueuePageListEl, ca restul functiilor init* din fisier.
    function initOfflineQueuePage() {
        if (!offlineQueuePageListEl || !window.CaliOffline) return;
        var body = document.body;

        var maxEl = document.getElementById('offlinequeue-max');
        if (maxEl) {
            maxEl.textContent = (body.dataset.offlineMaxPrefix || '') + ' ' + formatOfflineQueueCount(window.CaliOffline.MAX_QUEUE_SIZE);
        }

        var syncBtn = document.getElementById('offlinequeue-sync-btn');
        if (syncBtn) {
            syncBtn.addEventListener('click', function () {
                probeConnectivity().then(function (connectivity) {
                    if (connectivity === 'ONLINE') {
                        syncQueue();
                    } else {
                        showOfflineErrorToast({ message: body.dataset.offlineSyncStillOffline });
                    }
                });
            });
        }
    }
    initOfflineQueuePage();

    function initOfflineBanner() {
        if (!offlineBannerEl || !window.CaliOffline) return;
        var body = document.body;

        // Aplica SINCRON, la bootstrap, ultimul numar cunoscut al cozii
        // (cache-uit optimist in localStorage la fiecare updateOfflineQueueNavBadge()
        // reusit) - nu asteapta raspunsul asincron IndexedDB de mai jos (vezi
        // comentariul din updateOfflineQueueNavBadge() pt istoricul bug-ului).
        // refreshOfflineBanner(), apelat putin mai jos, corecteaza valoarea
        // (inclusiv la 0, daca intre timp coada a fost golita din alta parte -
        // ex. sincronizata pe alt tab) imediat ce citirea IndexedDB reuseste.
        try {
            var cachedCount = parseInt(localStorage.getItem(OFFLINE_QUEUE_BADGE_COUNT_KEY), 10);
            if (!isNaN(cachedCount)) updateOfflineQueueNavBadge(cachedCount);
        } catch (e) {
            // localStorage indisponibil - fara valoare optimista de aplicat,
            // badge-ul asteapta refreshOfflineBanner() de mai jos, ca inainte
        }

        var titleEl = document.getElementById('offline-banner-title');
        if (titleEl) titleEl.textContent = body.dataset.offlineTitle || '';
        var subtitleEl = document.getElementById('offline-banner-subtitle');
        if (subtitleEl) subtitleEl.textContent = body.dataset.offlineSubtitle || '';

        // Butonul "Continuă offline" din mockup = doar inchide avertismentul
        // (confirmat cu userul) - nu declanseaza niciun flux suplimentar; badge-ul
        // din navbar/pagina /offline-queue (daca exista iteme) ramane neatinse
        // de acest buton.
        var dismissBtn = document.getElementById('offline-banner-dismiss');
        if (dismissBtn) {
            dismissBtn.setAttribute('aria-label', body.dataset.offlineCloseLabel || '');
            dismissBtn.addEventListener('click', function () {
                offlineWarningDismissed = true;
                try { sessionStorage.setItem(OFFLINE_WARNING_DISMISSED_KEY, '1'); } catch (e) { /* vezi comentariul de mai sus */ }
                refreshOfflineBanner();
            });
        }

        // 'online'/visibilitychange sunt doar declansatori - nesiguri singuri
        // (navigator.onLine poate fi true fara conectivitate reala), de-aia
        // maybeSyncQueue() de mai jos face intai o proba REALA inainte de
        // orice incercare de sincronizare.
        //
        // Reincercare suplimentara a precache-ului offline (formulare +
        // fontul de iconite), raportata de un user real 2026-09-08, teren cu
        // conexiune intermitenta (PNC Calimani) - simptom: iconitele bi-*
        // aparute ca patratele goale (tofu) pe offline.html. Cauza: fetch-urile
        // din prewarmOfflineForms()/prewarmIconFont() folosesc .catch(()=>{})
        // (esecul unui fetch individual nu trebuie sa opreasca precache-ul
        // celorlalte) - OFFLINE_PREWARM_FLAG (throttle "o singura runda per
        // sesiune de tab") se seteaza insa NECONDITIONAT dupa Promise.all,
        // chiar daca unele fetch-uri au esuat silentios din lipsa reala de
        // conexiune. Pe o conexiune intermitenta, prima incercare (la vizita
        // pe Home) poate nimeri exact un moment fara semnal - flag-ul ramane
        // "consumat" pt tot restul sesiunii de tab, fara nicio reincercare
        // pana la urmatorul controllerchange (deploy nou) sau tab nou. Fix:
        // la fiecare revenire reala de conectivitate, resetam flag-ul si
        // reincercam - exact acelasi tipar deja folosit la controllerchange
        // (bypassHomeGate=true, stim ca suntem online - fix real 2026-09-07).
        window.addEventListener('online', function () {
            refreshOfflineBanner();
            maybeSyncQueue();
            try {
                sessionStorage.removeItem(OFFLINE_PREWARM_FLAG);
            } catch (e) {
                // sessionStorage indisponibil (mod privat etc.) - fara throttle
                // de resetat, prewarmOfflineForms() ruleaza oricum mai jos
            }
            prewarmOfflineForms(true);
            prewarmIconFont();
        });
        window.addEventListener('offline', function () {
            offlineWarningDismissed = false;
            try { sessionStorage.removeItem(OFFLINE_WARNING_DISMISSED_KEY); } catch (e) { /* vezi comentariul de mai sus */ }
            refreshOfflineBanner();
        });
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') maybeSyncQueue();
        });

        // Plasa de siguranta suplimentara, complementara evenimentelor de mai
        // sus - gasit real 2026-08-12, testare pe telefon: la revenirea dintr-
        // un mod avion REAL (nu doar Wi-Fi/date oprite din setari), evenimentul
        // 'online' nu se declanseaza fiabil pe Chrome mobil (limitare de
        // platforma cunoscuta, nu bug de aplicatie) - userul a vazut coada
        // sincronizandu-se abia la urmatoarea logare (incarcare noua de
        // pagina), nu imediat la iesirea din mod avion. Un poll periodic,
        // activ DOAR cat timp coada nu e goala (evita trafic de retea inutil
        // cand nu e nimic de sincronizat), reincearca proba de conectivitate
        // la fiecare 30s, indiferent daca vreun eveniment browser a apucat sa
        // se declanseze - in cel mai rau caz, o intarziere de 30s fata de
        // revenirea reala a conexiunii, nu o asteptare nedeterminata pana la
        // urmatoarea navigare/logare.
        setInterval(function () {
            if (!window.CaliOffline || offlineSyncInProgress) return;
            window.CaliOffline.count().then(function (n) {
                if (n > 0) maybeSyncQueue();
            });
        }, 30000);

        refreshOfflineBanner();
        maybeSyncQueue();

        // Toast-ul de "salvat offline" amanat de pe pagina VECHE (vezi
        // comentariul din queueObservationOffline()) - consumat o singura data
        // aici, pe pagina NOUA (dupa reload), cu toata durata lui reala (9s,
        // vezi fragments/offline-banner.html), deja stivuit corect sub
        // avertisment daca acesta e vizibil. Sters din sessionStorage imediat
        // dupa consum, ca sa nu reapara la un refresh manual ulterior.
        try {
            var pendingToastReason = sessionStorage.getItem(OFFLINE_SAVED_TOAST_PENDING_KEY);
            if (pendingToastReason) {
                sessionStorage.removeItem(OFFLINE_SAVED_TOAST_PENDING_KEY);
                showOfflineSavedToast(pendingToastReason);
            }
        } catch (e) {
            // sessionStorage indisponibil - nimic de consumat (deja aratat
            // sincron, pe pagina veche, in queueObservationOffline())
        }
    }
    initOfflineBanner();

    // -- Sincronizare coada offline la revenirea conexiunii ---------------------
    // Reutilizeaza direct endpoint-urile POST existente (/phenology, /disturbance,
    // /soil), ca multipart/form-data - fara niciun endpoint nou. Token CSRF
    // proaspat cerut la fiecare item (GET .../new, acelasi endpoint deja
    // precache-uit de service worker) - tokenul din pagina cache-uita offline nu
    // e reutilizat (ar putea fi legat de o sesiune expirata intre timp).
    var offlineSyncInProgress = false;

    // Bug real raportat de user 2026-09-05 (video+captura pe Android SI iPhone
    // - coada ramasa la nesfarsit pe "Se sincronizeaza... (N)", desi userul
    // putea confirma ca observatiile chiar ajungeau pe server): niciuna din
    // cele 2 cereri reale de sincronizare (GET .../new pt token proaspat, POST-ul
    // efectiv cu pozele) nu avea vreun timeout - spre deosebire de proba de
    // conectivitate (probeConnectivity, mai sus), care foloseste deja
    // AbortController+setTimeout. probeConnectivity() verifica doar conexiunea
    // INAINTE de a porni sincronizarea (un mic payload de 50KB) - nu garanteaza
    // nimic despre o cerere REALA ulterioara (pagina .../new sau POST-ul cu
    // poze), care poate ramane suspendata la nesfarsit pe o conexiune mobila
    // instabila chiar dupa revenirea semnalului (tipic exact scenariul PWA
    // offline - semnal recapatat in teren, dar inca fluctuant). Fara timeout,
    // fetch()-ul nu se rezolva NICIODATA, syncQueue() ramane blocat pe acel
    // item la nesfarsit (reduce() secvential), offlineSyncInProgress nu mai
    // ajunge niciodata la false, iar UI-ul ramane agatat pe "Se sincronizeaza..."
    // definitiv - afecteaza AMBELE platforme (Android+iPhone), spre deosebire
    // de bug-ul WebKit-only din 2026-08-28 (vezi CLAUDE.md radacina), fiind un
    // gol structural, nu un bug specific unui motor de browser. Fix: fiecare
    // din cele 2 cereri primeste propriul timeout (AbortController), tratat ca
    // 'network-error' (acelasi cod deja existent pt orice fetch esuat -
    // itemul ramane PENDING, se reincearca la urmatorul declansator, batch-ul
    // continua cu urmatorul item din coada, nu se blocheaza).
    var SYNC_CSRF_FETCH_TIMEOUT_MS = 20000;
    var SYNC_POST_FETCH_TIMEOUT_MS = 180000;

    function fetchWithTimeout(url, options, timeoutMs) {
        var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var timedOut = false;
        var timeoutId = controller ? setTimeout(function () {
            timedOut = true;
            controller.abort();
        }, timeoutMs) : null;
        var opts = Object.assign({}, options, { signal: controller ? controller.signal : undefined });
        return fetch(url, opts).then(function (response) {
            if (timeoutId) clearTimeout(timeoutId);
            return response;
        }, function (err) {
            if (timeoutId) clearTimeout(timeoutId);
            // AbortError nativ ("The operation was aborted"/"The user aborted
            // a request", diferit intre Chrome/Safari) nu spune userului CE
            // s-a intamplat de fapt - un mesaj explicit, vizibil in toast-ul
            // de eroare (offline.banner.syncIncomplete, syncQueue() mai jos),
            // e mult mai util la diagnosticare de la distanta.
            throw timedOut ? new Error('Timeout - conexiune prea lenta (' + Math.round(timeoutMs / 1000) + 's)') : err;
        });
    }

    function extractCsrfTokenFromHtml(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var input = doc.querySelector('input[name="_csrf"]');
        return input ? input.value : null;
    }

    // Detecteaza un redirect spre pagina de login (sesiune expirata/invalida) -
    // reutilizat atat la pasul GET (reimprospatare token CSRF) cat si la POST-ul
    // efectiv de mai jos (syncOneRecord), care altfel ar trata ORICE redirect ca
    // succes, fara sa verifice si destinatia lui.
    function isLoginRedirect(response) {
        return response.redirected && /\/login(\?|$)/.test(response.url);
    }

    // Destinatia AsTEPTATA de succes a POST-ului de sincronizare pt un record -
    // determinabila client-side, fara nicio presupunere despre server: actiunea
    // e mereu fortata la 'list' (buildOfflineFormData), iar redirectAfterCreate()
    // (identic in PhenologyController/DisturbanceController/SoilController) e
    // determinist: "OBSERVATIONS".equals(returnTo) ? /observations : /<modul>.
    function expectedSyncRedirectPath(record) {
        var path = (record.returnTo === 'OBSERVATIONS')
            ? document.body.dataset.offlineObservationsUrl
            : record.endpoint;
        return new URL(path, window.location.origin).pathname;
    }

    // Whitelist, NU blacklist, pe destinatia redirectului - vezi isLoginRedirect
    // de mai sus, care acopera doar /login. response.redirected SINGUR nu poate
    // fi tratat ca succes (vezi throwUnexpectedSyncRedirect mai jos): un gate
    // Spring Security care intercepteaza cereri autentificate si face redirect
    // spre altceva decat /login (ex. GdprGateFilter -> /gdpr-accept, daca
    // versiunea GDPR a fost schimbata cat timp userul avea observatii in coada)
    // ar fi confundat cu succes de o simpla verificare "a fost redirect". O
    // blacklist (inca o exceptie explicita, ca isLoginRedirect) ar cere
    // sincronizare manuala JS<->Java la fiecare gate nou - o whitelist esueaza
    // fail-closed automat, fara nicio modificare viitoare in acest fisier.
    function isExpectedSyncRedirect(record, response) {
        if (!response.redirected) return false;
        try {
            return new URL(response.url).pathname === expectedSyncRedirectPath(record);
        } catch (e) {
            return false;
        }
    }

    function throwUnexpectedSyncRedirect(response) {
        var err = new Error('Sincronizare blocata de un redirect neasteptat: ' + response.url);
        err.code = 'UNEXPECTED_REDIRECT';
        err.redirectUrl = response.url;
        throw err;
    }

    function throwSessionExpired() {
        var sessionErr = new Error('Sesiune expirata');
        sessionErr.code = 'SESSION_EXPIRED';
        throw sessionErr;
    }

    // Diagnostic minimal pastrat (GET status/redirected) - util daca sincronizarea
    // esueaza vreodata din nou cu un motiv necunoscut, fara sa mai umfle toast-ul
    // cu valori de cookie/token (vezi CLAUDE.md radacina, sectiunea Offline/PWA,
    // pt istoricul complet al bug-ului 403 din 2026-08-28 si de ce aceasta
    // informatie a fost suficienta sa gaseasca root cause-ul real).
    function fetchFreshCsrfToken(newFormUrl) {
        var diag = { status: null, redirected: null };
        return fetchWithTimeout(newFormUrl, {
            credentials: 'same-origin',
            cache: 'no-store'
        }, SYNC_CSRF_FETCH_TIMEOUT_MS).then(function (response) {
            diag.status = response.status;
            diag.redirected = response.redirected;
            if (isLoginRedirect(response)) throwSessionExpired();
            return response.text();
        }).then(function (html) {
            var token = extractCsrfTokenFromHtml(html);
            if (!token) throw new Error('Token CSRF negasit in formularul reincarcat');
            return { token: token, diag: diag };
        });
    }

    // Converteste un epoch ms (record.createdAt, momentul REAL al capturii
    // offline) intr-un string "yyyy-MM-ddTHH:mm:ss" legabil direct de Spring
    // MVC la un camp LocalDateTime (format ISO_LOCAL_DATE_TIME, fara adnotare
    // @DateTimeFormat necesara). Construit manual din componentele LOCALE ale
    // datei (nu .toISOString(), care intoarce ora UTC) - trebuie sa reprezinte
    // aceeasi "ora de perete" pe care ar reprezenta-o LocalDateTime.now() pe
    // server, nu un instant UTC convertit.
    function formatLocalDateTimeForServer(epochMs) {
        var d = new Date(epochMs);
        function pad(n) { return (n < 10 ? '0' : '') + n; }
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
            'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    }

    // Reconstruieste FormData din campurile plate (Array = valori multiple, ex.
    // "types" la Perturbari) + poze (Blob-uri stocate direct in IndexedDB, vezi
    // PR1). "action" e fortat la 'list' la sincronizare in fundal - "Salvare si
    // formular nou" nu are sens fara interactiune reala a userului.
    //
    // Bug real gasit 2026-08-28, DOAR pe iPhone: fetch()-ul de sincronizare
    // trimitea un CORP COMPLET GOL (Content-Length: 0, confirmat direct din
    // logul serverului - Content-Type continea totusi boundary-ul multipart
    // corect, deci fetch() STIA ca trimite FormData, dar serializarea efectiva
    // a esuat silentios) - WebKit are bug-uri documentate legate de Blob-uri
    // citite din IndexedDB si refolosite direct intr-un FormData/fetch (vezi
    // CLAUDE.md radacina). Sesiunea/CSRF-ul erau intotdeauna corecte (verificat
    // direct in log: SecurityContextHolder arata userul autentificat corect) -
    // pista falsa urmarita ore intregi. Fix: fiecare Blob e "rematerializat"
    // explicit (arrayBuffer() -> Blob nou, in memorie proaspata) chiar inainte
    // de atasare, in loc sa fie refolosit direct Blob-ul original din
    // IndexedDB - functia devine asincrona (Promise), din cauza arrayBuffer().
    function buildOfflineFormData(record, csrfToken) {
        var photoBlobPromises = record.photos.map(function (photo) {
            return photo.blob.arrayBuffer().then(function (buffer) {
                return new Blob([buffer], { type: photo.blob.type || 'application/octet-stream' });
            });
        });
        return Promise.all(photoBlobPromises).then(function (freshBlobs) {
            var formData = new FormData();
            Object.keys(record.fields).forEach(function (key) {
                var value = record.fields[key];
                if (Array.isArray(value)) {
                    value.forEach(function (v) { formData.append(key, v); });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, value);
                }
            });
            record.photos.forEach(function (photo, index) {
                formData.append('photos', freshBlobs[index], photo.name);
            });
            formData.set('action', 'list');
            formData.set('_csrf', csrfToken);
            formData.set('clientId', record.clientId);
            // data efectiva a capturii (record.createdAt = momentul scrierii in
            // coada IndexedDB, in teren) - vezi CLAUDE.md radacina, capturedAt
            formData.set('capturedAt', formatLocalDateTimeForServer(record.createdAt));
            if (record.returnTo) formData.set('returnTo', record.returnTo);
            return formData;
        });
    }

    // Rezultatul unui singur item: 'success' (sters din coada), 'failed'
    // (eroare de VALIDARE/domeniu - server intoarce 200 cu formularul re-randat,
    // nu un redirect; marcat definitiv FAILED, fara reincercare automata, datele
    // fiind structural invalide) sau 'network-error' (ramane PENDING, se
    // reincearca la urmatorul declansator). SESSION_EXPIRED e ARUNCATA mai
    // departe (nu prinsa aici) - opreste tot batch-ul curent, gestionata in
    // syncQueue().
    //
    // response.redirected SINGUR nu e suficient pt "succes" - un POST RESPINS
    // (ex. sesiunea a expirat exact intre pasul GET de mai sus si acest POST)
    // tot rezulta intr-un redirect (spre /login), pe care fetch() il urmeaza
    // automat (redirect:'follow'); fara verificarea explicita de mai jos, un
    // asemenea esec ar fi confundat cu succes si itemul sters din coada FARA
    // sa fi fost salvat vreodata pe server. Aceeasi verificare (isLoginRedirect)
    // ca la pasul GET din fetchFreshCsrfToken.
    function syncOneRecord(record) {
        // Plasa de siguranta (nu prevenirea principala, care e la alegerea
        // pozei - vezi STORAGE_MAX_FILE_SIZE_BYTES/showPhotoSizeToast mai sus,
        // initAccumulatingFileInputs()): daca totusi o poza prea mare a ajuns
        // in coada (limita serverului s-a schimbat intre timp, sau un bug ar
        // fi lasat-o sa treaca de verificarea de la adaugare), NU incercam
        // deloc fetch()-ul real - serverul ar respinge-o oricum, iar raspunsul
        // NU ar fi un HTTP curat de verificat (MaxUploadSizeExceededException
        // e aruncata din MultipartFilter, INAINTE de DispatcherServlet - fetch()
        // primeste doar "Failed to fetch", o eroare de retea generica, imposibil
        // de distins de o problema reala de conexiune - verificat empiric
        // 2026-08-31, vezi CLAUDE.md radacina). Limitele sunt citite LIVE din
        // pagina curenta (STORAGE_MAX_*_BYTES), nu din momentul in care itemul
        // a fost pus in coada, ca sa reflecte config-ul ACTUAL al serverului.
        var totalPhotoBytes = record.photos.reduce(function (sum, p) { return sum + (p.blob ? p.blob.size : 0); }, 0);
        var oversizedPhoto = record.photos.filter(function (p) { return p.blob && p.blob.size > STORAGE_MAX_FILE_SIZE_BYTES; })[0];
        if (oversizedPhoto || totalPhotoBytes > STORAGE_MAX_REQUEST_SIZE_BYTES) {
            record.status = 'FAILED';
            record.lastError = 'FILE_TOO_LARGE';
            return window.CaliOffline.update(record).then(function () {
                return { clientId: record.clientId, outcome: 'failed' };
            });
        }

        var newFormUrl = record.endpoint + '/new';
        var csrfDiag = null;
        return fetchFreshCsrfToken(newFormUrl).then(function (result) {
            csrfDiag = result.diag;
            return buildOfflineFormData(record, result.token);
        }).then(function (formData) {
            return fetchWithTimeout(record.endpoint, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
                redirect: 'follow'
            }, SYNC_POST_FETCH_TIMEOUT_MS);
        }).then(function (response) {
            if (isLoginRedirect(response)) throwSessionExpired();
            if (isExpectedSyncRedirect(record, response)) {
                return window.CaliOffline.remove(record.clientId).then(function () {
                    return { clientId: record.clientId, outcome: 'success' };
                });
            }
            // Orice ALT redirect (ex. gate-ul GDPR, sau orice mecanism similar
            // viitor) NU e succes, desi response.redirected e true - vezi
            // isExpectedSyncRedirect mai sus. Tratat analog SESSION_EXPIRED:
            // opreste tot batch-ul curent, itemul NU e sters din coada.
            if (response.redirected) throwUnexpectedSyncRedirect(response);
            // 403 (CSRF respins/acces interzis - CustomAccessDeniedHandler face
            // FORWARD la /access-denied, nu redirect, deci raspunsul ajunge aici,
            // nu la ramura de mai sus) NU e o eroare de VALIDARE a datelor
            // introduse de user - e un esec de securitate/retea, posibil
            // TEMPORAR (ex. tokenul CSRF proaspat de mai sus a venit dintr-un
            // fallback din cache-ul service worker-ului, la o reconectare
            // instabila/partiala, nu de la reteaua reala). Tratat ca network-error
            // (ramane PENDING, se reincearca la urmatorul declansator), nu marcat
            // FAILED definitiv - altfel un item complet valid ar ramane blocat
            // pentru totdeauna dupa un singur eveniment tranzitoriu.
            if (response.status === 403) {
                // Diagnostic REDUS (2026-08-28) - versiunea completa (token/
                // cookie comparate direct) s-a dovedit o pista falsa: Spring
                // Security "maschează" tokenul afisat in pagina (protectie
                // BREACH), deci difera mereu de valoarea bruta din cookie,
                // inclusiv in cazurile care CHIAR reusesc - nimic anormal
                // acolo. Pastrat doar strict esentialul, ca toast-ul sa
                // incapa pe ecran.
                return { clientId: record.clientId, outcome: 'network-error', error: new Error('Cerere respinsa (403) la sincronizare [GET status=' + (csrfDiag && csrfDiag.status) + ' redirected=' + (csrfDiag && csrfDiag.redirected) + ']') };
            }
            record.status = 'FAILED';
            record.lastError = 'VALIDATION';
            return window.CaliOffline.update(record).then(function () {
                return { clientId: record.clientId, outcome: 'failed' };
            });
        }).catch(function (err) {
            if (err && (err.code === 'SESSION_EXPIRED' || err.code === 'UNEXPECTED_REDIRECT')) throw err;
            return { clientId: record.clientId, outcome: 'network-error', error: err };
        });
    }

    function showOfflineSessionExpiredToast() {
        var toastEl = document.getElementById('offline-error-toast');
        var bodyEl = document.getElementById('offline-error-toast-body');
        if (!toastEl || !bodyEl) return;
        bodyEl.textContent = document.body.dataset.offlineSessionExpired || '';
        new bootstrap.Toast(toastEl).show();
    }

    // FIFO, SECVENTIAL (nu paralel) - reduce riscul de reordonare a codurilor de
    // referinta generate si de suprasolicitare a serverului pe o conexiune
    // mobila abia revenita. Un singur lacat in-memory (offlineSyncInProgress)
    // previne 2 cicluri simultane pe acelasi tab (revenire din fundal +
    // eveniment 'online' aproape concomitent) - risc rezidual acceptat pt 2+
    // taburi deschise simultan.
    function syncQueue() {
        if (offlineSyncInProgress || !window.CaliOffline) return Promise.resolve();
        // Fara toast aici, deliberat - syncQueue() poate fi declansat automat,
        // repetat (poll la 30s, evenimentul 'online', fiecare incarcare de
        // pagina), iar un toast la fiecare incercare ar deveni spam pt un cont
        // care structural nu poate sincroniza NICIODATA aceasta coada (vezi
        // canCurrentUserCreateObservations). Explicatia vizibila permanenta
        // stă pe /offline-queue (notita + buton dezactivat cu tooltip,
        // renderOfflineQueuePage) - butonul manual de-acolo fiind deja
        // dezactivat, nu mai exista niciun declansator UI care ar avea nevoie
        // de un mesaj imediat aici.
        if (!canCurrentUserCreateObservations()) return Promise.resolve();
        offlineSyncInProgress = true;
        // indicatorul "Se sincronizeaza..." trebuie sa apara IMEDIAT, nu doar
        // dupa ce primul item se termina (poate dura cateva secunde pe o
        // conexiune mobila lenta) - fara acest apel, banner-ul ar ramane cu
        // textul/butoanele vechi vizibile pana la primul rezultat
        refreshOfflineBanner();

        return window.CaliOffline.getAll().then(function (records) {
            var pending = records.filter(function (r) { return r.status !== 'FAILED'; });
            return pending.reduce(function (chain, record) {
                return chain.then(function (results) {
                    return syncOneRecord(record).then(function (result) {
                        refreshOfflineBanner();
                        return results.concat([result]);
                    });
                });
            }, Promise.resolve([]));
        }).then(function (results) {
            offlineSyncInProgress = false;
            refreshOfflineBanner();
            // Diagnostic 2026-08-28: 'network-error' era pana acum COMPLET
            // tacut (gandit pt esecuri tranzitorii - 403/fetch esuat - care se
            // repara singure la urmatoarea reincercare) - dar daca esecul e
            // PERSISTENT, userul nu avea niciun mijloc sa vada de ce (nici
            // eroare vizibila pe /offline-queue, care arata text doar pt
            // FAILED, nu si pt network-error). Arata acum motivul tehnic
            // exact, ca sa poata fi diagnosticat de la distanta, fara consola.
            //
            // Bug real raportat de user 2026-09-07: cu 2+ iteme esuate simultan
            // (nu doar unul), toast-ul lua mereu DOAR primul rezultat ([0]) si
            // arata textul hardcodat la singular ("pentru una din observatii"),
            // desi mai multe ramasesera in coada - inexact, nu doar cosmetic.
            // Fix: numara TOATE esecurile, alege mesajul potrivit - singularul
            // existent (neschimbat) la exact 1, un mesaj nou, pluralizat prin
            // acelasi formatOfflineQueueCount() deja folosit pt "N observatii
            // in coada", la 2+.
            var networkErrors = results.filter(function (r) { return r.outcome === 'network-error'; });
            if (networkErrors.length === 1) {
                var detail = networkErrors[0].error && networkErrors[0].error.message;
                showOfflineErrorToast({
                    message: (document.body.dataset.offlineSyncIncomplete || '') + (detail ? ' (' + detail + ')' : '')
                });
            } else if (networkErrors.length > 1) {
                var countPhrase = formatOfflineQueueCount(networkErrors.length);
                showOfflineErrorToast({
                    message: (document.body.dataset.offlineSyncIncompleteMultiple || '').replace('{0}', countPhrase)
                });
            }
            return results;
        }).catch(function (err) {
            offlineSyncInProgress = false;
            refreshOfflineBanner();
            if (err && err.code === 'SESSION_EXPIRED') {
                showOfflineSessionExpiredToast();
            } else if (err && err.code === 'UNEXPECTED_REDIRECT') {
                showOfflineErrorToast(err);
            }
        });
    }

    function maybeSyncQueue() {
        probeConnectivity().then(function (connectivity) {
            if (connectivity === 'ONLINE') syncQueue();
        });
    }

    window.CaliOffline.probeConnectivity = probeConnectivity;
    window.CaliOffline.refreshBanner = refreshOfflineBanner;
    window.CaliOffline.sync = syncQueue;

    // Precache proactiv al celor 3 formulare de creare + pagina /offline-queue,
    // direct de pe Home (bug real raportat: login o singura data online -> mod
    // avion -> formularele raman inaccesibile offline, fiindca service-worker.js
    // le cache-uieste azi DOAR reactiv, la o vizita online reusita a FIECARUIA
    // in parte - niciodata la instalare, vezi OFFLINE_CAPABLE_NAVIGATIONS din
    // service-worker.js). /offline-queue adaugata 2026-08-13, odata cu mutarea
    // listei complete a cozii pe pagina proprie - trebuie sa fie accesibila
    // offline la fel ca formularele, altfel un user cu observatii in coada nu-
    // si poate vedea/sterge coada exact cand chiar are nevoie (fara conexiune).
    // Fire-and-forget: rezultatul nu conteaza pt sesiunea curenta, doar
    // "incalzeste" cache-ul SW pt o eventuala vizita offline viitoare - un 403
    // (ex. rol Admin, fara acces la formulare) nu se cache-uieste oricum
    // (branch-ul dedicat din service-worker.js verifica response.ok inainte de
    // cache.put). Throttle la o singura runda REUSITA per sesiune de tab
    // (sessionStorage), ca sa nu repete cele 4 cereri la fiecare revizitare a
    // Home in aceeasi sesiune - dar flag-ul se seteaza abia DUPA ce toate cele
    // 4 cereri s-au terminat (Promise.all), nu la pornirea lor. Bug real gasit
    // 2026-08-19 (userul a navigat direct de pe Home spre /phenology/new, fara
    // pauza pe Home): flag-ul era setat imediat, inainte ca fetch-urile sa
    // apuce sa se termine; navigarea reala care a urmat distrugea contextul JS
    // al paginii Home, iar fetch-urile inca "in zbor" pt disturbance/new,
    // soil/new, offline-queue erau anulate de browser (fara keepalive) -
    // /phenology/new tot ajungea cache-uit, dar reactiv, prin navigarea reala
    // a userului, nu prin acest precache. Cu flag-ul deja "consumat", nicio
    // revenire ulterioara pe Home nu mai relua precache-ul pt restul, ramase
    // needisponibile offline. Fix: keepalive:true (fetch-ul supravietuieste
    // navigarii care l-a intrerupt) + flag setat abia dupa Promise.all.
    var OFFLINE_PREWARM_FORMS = ['phenology/new', 'disturbance/new', 'soil/new', 'offline-queue'];
    var OFFLINE_PREWARM_FLAG = 'cali-offline-prewarm-done';
    var OFFLINE_CACHE_IDENTITY_KEY = 'cali-offline-cache-identity';
    var CAN_CREATE_OBSERVATIONS_KEY = 'cali-can-create-observations';

    // Fontul de iconite (bootstrap-icons.woff2/.woff) NU se cache-uieste azi
    // decat "din intamplare", la prima randare online a unei pagini cu
    // iconite (branch-ul generic cache-first din service-worker.js, scopat pe
    // request.destination==='font', nu pe o lista explicita) - fara nicio
    // garantie ca acea intrare supravietuieste unui update de aplicatie
    // (CACHE_VERSION nou -> intregul cache vechi se sterge la activate).
    // Bug real gasit 2026-08-26 (raportat de user - iconita X de la butonul
    // "Salvare si formular nou" al formularului Fenologie nu se incarca
    // offline, verificat empiric cu Playwright: fara fontul in cache, glyph-ul
    // dispare complet, ramane doar sageata nativa a dropdown-ului) - daca
    // userul ajunge offline dupa un update, inainte de orice randare online
    // ulterioara, fontul lipseste definitiv din cache pana la urmatoarea
    // vizita online, afectand orice iconita bi-* de pe paginile offline.
    // Nu poate fi pusa direct in APP_SHELL cu o cale hardcodata - Spring/
    // webjars-locator ii insereaza numarul de versiune in path (vezi
    // fragments/head-assets.html, th:href="@{/webjars/bootstrap-icons/...}}"),
    // numar care se poate schimba la un upgrade viitor de dependinta; o cale
    // fixa in service-worker.js ar deveni gresita silentios la acel upgrade.
    // Descoperita aici DINAMIC, din <link>-ul deja randat de Thymeleaf (calea
    // reala, versionata, exact cea pe care orice pagina reala o va cere) -
    // acelasi mecanism fetch()+keepalive ca formularele de mai sus,
    // interceptat in service-worker.js prin potrivire pe nume de fisier
    // (isOfflinePrewarmAsset), nu pe destination (un fetch() programatic are
    // mereu destination gol, nu 'font' - branch-ul generic nu l-ar prinde).
    // Bug real raportat de user 2026-09-07 (gasit + reprodus end-to-end cu Playwright,
    // pe 2 conturi dedicate, unul ADMIN unul RANGER): Cache Storage-ul e per-browser,
    // NU per-cont autentificat - cele 4 pagini offline-capabile (OFFLINE_PREWARM_FORMS)
    // sunt HTML randat server-side, cu navbar-ul/CSRF-ul contului activ la momentul
    // cache-uirii. Daca un cont A (ex. Ranger) le cache-uieste, apoi un cont B (ex.
    // Admin) se logheaza pe ACELASI browser, propriul lui prewarm poate esua (403,
    // Admin fara acces la formulare de creare) - fetch-ul esuat NU suprascrie cache-ul
    // (branch-ul de prewarm din service-worker.js scrie doar la response.ok), deci
    // pagina veche a lui A ramane agatata la nesfarsit. Offline, B ajunge sa vada
    // formularul cu identitatea/meniul/CSRF-ul lui A (inclusiv linkuri restrictionate
    // rolului lui A, ex. "Validare") - confuzie reala, desi cookie-urile raman corect
    // ale lui B (nicio compromitere reala de autorizare server-side, verificat separat
    // la sincronizare: GET-ul de CSRF proaspat foloseste sesiunea REALA a lui B, care
    // primeste tot 403, observatia ramane blocata in coada, nimic nu se creeaza).
    //
    // Fix: la fiecare identitate NOUA detectata (username curent, expus de server pe
    // <body data-current-username>, comparat cu ultima valoare tinuta in localStorage
    // - persista peste restart de tab/browser, la fel ca si Cache Storage-ul insusi),
    // evacuam NECONDITIONAT cele 4 intrari din cache INAINTE de a incerca reimprospatarea
    // - nu doar conditionat de un raspuns 403 ulterior. Motiv: fetch-urile astea de
    // prewarm au deja un istoric documentat de esecuri din motive NELEGATE de acces
    // (vezi bug-ul de mai sus, 2026-08-19 - navigarea reala poate anula fetch-ul inainte
    // sa se termine) - o evacuare conditionata doar de raspunsul 403 ar rata exact acele
    // cazuri (fetch-ul nu ajunge niciodata la raspuns), lasand identitatea gresita
    // agatata in cache pt un motiv diferit de 403. Cele 2 esecuri posibile NU sunt
    // simetrice: daca NU evacuam preventiv si refetch-ul esueaza (orice motiv), riscul
    // e sa ramana identitatea GRESITA cache-uita; daca evacuam preventiv si refetch-ul
    // esueaza, riscul e doar indisponibilitate TEMPORARA offline (fallback generic
    // offline.html, corect din punct de vedere al securitatii) - a doua consecinta e
    // strict mai sigura, merita acceptata ca pret pt garantia "niciodata identitate
    // gresita". Pt un cont care CHIAR are acces, refetch-ul reuseste normal imediat
    // dupa evacuare (in acelasi lant de promisiuni, inainte ca userul sa apuce sa
    // mearga offline), deci zero regresie practica de disponibilitate.
    //
    // Reseteaza si OFFLINE_PREWARM_FLAG (throttle-ul "o singura runda per sesiune de
    // tab") - altfel un logout+login cu un cont DIFERIT in ACELASI tab ar ramane
    // blocat de throttle-ul contului anterior, sarind complet peste reimprospatare.
    function evictOfflineCacheIfIdentityChanged() {
        if (!('caches' in window) || !document.body) return Promise.resolve();
        var currentUsername = document.body.dataset.currentUsername;
        if (!currentUsername) return Promise.resolve(); // anonim (pagini publice) - nimic de verificat
        // Sincronizat NECONDITIONAT (nu doar la schimbare de identitate) - citit de
        // offline.html (static, fara Thymeleaf) ca sa ascunda cele 3 linkuri de
        // creare pt un cont fara acces (ex. Admin), vezi bug real 2026-09-07
        // (ERR_FAILED pe telefon la click, raportat de user - offline.html arata
        // identic tuturor rolurilor, desi Admin n-are voie sa creeze observatii
        // nici online). Trebuie inaintea oricarui early-return de mai jos, ca sa
        // ramana la zi chiar si cand identitatea NU s-a schimbat fata de ultima
        // vizita (userul revine pe Home cu acelasi cont).
        try {
            localStorage.setItem(CAN_CREATE_OBSERVATIONS_KEY, document.body.dataset.canCreateObservations || 'false');
        } catch (e) {
            // localStorage indisponibil - offline.html ramane la comportamentul
            // implicit (arata linkurile), acelasi fail-safe ca mai jos
        }
        var storedUsername;
        try {
            storedUsername = localStorage.getItem(OFFLINE_CACHE_IDENTITY_KEY);
        } catch (e) {
            return Promise.resolve(); // localStorage indisponibil (mod privat etc.) - nu putem detecta schimbarea, no-op sigur
        }
        if (storedUsername === currentUsername) return Promise.resolve();
        try {
            localStorage.setItem(OFFLINE_CACHE_IDENTITY_KEY, currentUsername);
            sessionStorage.removeItem(OFFLINE_PREWARM_FLAG);
        } catch (e) {
            // sessionStorage indisponibil - fara throttle de resetat, continuam oricum
        }
        return caches.keys().then(function (names) {
            var shellName = names.filter(function (name) {
                return name.indexOf('cali-app-shell-') === 0;
            })[0];
            if (!shellName) return;
            return caches.open(shellName).then(function (cache) {
                return Promise.all(OFFLINE_PREWARM_FORMS.map(function (path) {
                    return cache.delete(APP_BASE_URL + path);
                }));
            });
        }).catch(function () {});
    }

    function prewarmIconFont() {
        var link = document.querySelector('link[href*="bootstrap-icons"]');
        if (!link) return Promise.resolve();
        return fetch(link.href, { credentials: 'same-origin', keepalive: true }).then(function (response) {
            return response.ok ? response.text() : '';
        }).then(function (cssText) {
            var urls = [];
            var regex = /url\(["']?([^"')]+)["']?\)/g;
            var match;
            while ((match = regex.exec(cssText)) !== null) {
                urls.push(new URL(match[1], link.href).href);
            }
            return Promise.all(urls.map(function (url) {
                return fetch(url, { credentials: 'same-origin', keepalive: true }).catch(function () {});
            }));
        }).catch(function () {});
    }

    // Bug real raportat de user 2026-09-07: dupa un deploy nou (CACHE_VERSION
    // schimbat), cele 3 formulare + /offline-queue disparusera din cache -
    // fallback-ul generic offline.html aparea inclusiv la un click pe butoanele
    // "Observatie Fenologie/Perturbari/Sol" DIN offline.html, care ar trebui sa
    // duca la formularul REAL, precache-uit. Cauza: la controllerchange (mai
    // jos), reincercarea explicita apela prewarmOfflineForms() FARA bypassHome,
    // deci gate-ul de mai jos (pathname==='/home') o oprea de fiecare data cand
    // userul NU era exact pe Home in momentul in care update-ul de aplicatie
    // isi lua efectiv controlul (cazul tipic - reload-ul automat de mai jos
    // reincarca pagina CURENTA, nu Home) - comentariul vechi de aici ("sigur de
    // inregistrat neconditionat, e no-op oriunde altundeva") descria corect
    // COMPORTAMENTUL, dar rata consecinta reala: "no-op" insemna exact "cache-ul
    // nu se mai re-populeaza pana la urmatoarea vizita reala pe Home" - care in
    // teren poate sa nu se mai intample inainte ca userul sa ajunga offline.
    // Fix: parametrul bypassHomeGate (true DOAR la controllerchange, vezi mai
    // jos) inlocuieste verificarea de pathname cu acelasi semnal deja folosit
    // in tot fisierul pt "sunt pe o pagina autentificata" (prezenta bannerului
    // offline, inclus doar in layout-ul autentificat, nu si in login-layout) -
    // la controllerchange stim deja sigur ca suntem online (tocmai am preluat
    // un worker nou, care a cerut o cerere de retea reala), la fel ca
    // prewarmIconFont(), apelata deja neconditionat de pagina in acelasi loc.
    function prewarmOfflineForms(bypassHomeGate) {
        if (typeof APP_BASE_URL === 'undefined') return;
        if (!navigator.onLine) return;
        // evacuarea de cache stale cross-cont (vezi comentariul de la
        // evictOfflineCacheIfIdentityChanged) trebuie sa se termine COMPLET inainte
        // de gate-ul de Home/throttle de mai jos - o identitate noua reseteaza
        // throttle-ul, deci gate-ul trebuie evaluat DUPA, nu inainte/in paralel,
        // altfel un login cu cont nou, in acelasi tab, ar ramane blocat de
        // throttle-ul (inca nesters) al contului anterior.
        evictOfflineCacheIfIdentityChanged().then(function () {
            // Home s-a mutat de pe "/" pe "/home" (2026-08-12, "/" a devenit ruta
            // publica de Statistici) - verificarea trebuie actualizata la fel,
            // altfel precache-ul proactiv fie nu mai porneste niciodata (Home nu
            // mai e la radacina), fie porneste gresit pe pagina publica neautentificata
            if (!bypassHomeGate && window.location.pathname !== APP_BASE_URL + 'home') return;
            if (bypassHomeGate && !offlineBannerEl) return;
            try {
                if (sessionStorage.getItem(OFFLINE_PREWARM_FLAG)) return;
            } catch (e) {
                // sessionStorage indisponibil (mod privat etc.) - continuam oricum,
                // doar fara throttle intre navigari repetate pe Home
            }
            // conturile fara drept de creare (ex. ADMIN) primeau 403 la cele 3
            // formulare - raspuns necache-uit oricum (doar response.ok intra in
            // cache), dar fiecare cerere scria un "Access denied" in log-ul
            // serverului, ascunzand refuzurile reale printre ele. Pt ele nu se
            // incalzeste nicio pagina: nici /offline-queue - accesibila lor doar ca
            // informare (read-only) pe un device partajat, util doar online, nu offline
            // (decizie 2026-09-30). Fontul de iconite ramane pt toti (fara 403,
            // folosit si de offline.html).
            var prewarmPaths = canCurrentUserCreateObservations() ? OFFLINE_PREWARM_FORMS : [];
            return Promise.all(prewarmPaths.map(function (path) {
                return fetch(APP_BASE_URL + path, { credentials: 'same-origin', keepalive: true }).catch(function () {});
            }).concat([prewarmIconFont()])).then(function () {
                try {
                    sessionStorage.setItem(OFFLINE_PREWARM_FLAG, '1');
                } catch (e) {
                    // sessionStorage indisponibil - fara throttle, aceeasi situatie ca mai sus
                }
            });
        });
    }

    if ('serviceWorker' in navigator && typeof APP_BASE_URL !== 'undefined') {
        window.addEventListener('load', function () {
            navigator.serviceWorker.register(APP_BASE_URL + 'service-worker.js', { scope: APP_BASE_URL, updateViaCache: 'none' })
                .then(function (registration) {
                    // fortam verificarea la fiecare incarcare de pagina, nu doar la cel
                    // mult o data la ~24h (limitarea implicita a browserului) - browserul
                    // compara bytes-ul scriptului si instaleaza o versiune noua DOAR daca
                    // difera efectiv, deci nu se instaleaza nimic la vizitele fara schimbari
                    registration.update();
                    // asteptam un worker activ (deci client-ul curent devine "controlled",
                    // vezi clients.claim() din activate) inainte de a lansa cererile de
                    // incalzire - altfel n-ar fi interceptate/cache-uite de nimeni
                    return navigator.serviceWorker.ready;
                })
                .then(prewarmOfflineForms);
        });

        // Reincercare EXPLICITA la controllerchange - bug real gasit 2026-08-13,
        // dupa ce fix-ul cu waitUntil() (service-worker.js) singur nu rezolvase
        // complet problema (/offline-queue tot lipsea din cache dupa un deploy
        // proaspat, chiar cu secventa corecta de testare - app inchisa complet,
        // redeschisa, Home online inainte de mod avion). Cauza reala, diferita:
        // navigator.serviceWorker.ready (mai sus) NU asteapta ca update()-ul
        // declansat chiar inainte sa se termine - se rezolva imediat cu orice
        // worker e ACTIV in acel moment, care, la prima incarcare de dupa un
        // deploy proaspat, poate fi inca worker-ul VECHI (cel nou abia a
        // inceput sa se instaleze/activeze). Daca worker-ul vechi nu recunostea
        // inca un URL nou adaugat in OFFLINE_CAPABLE_NAVIGATIONS, fetch-ul de
        // precache trece pe langa el netratat - nimic nu se cache-uieste,
        // indiferent de waitUntil(). 'controllerchange' e semnalul GARANTAT de
        // spec ca noul worker a preluat efectiv controlul (clients.claim() din
        // activate) - la acel moment sigur ruleaza codul cel mai recent.
        // prewarmOfflineForms(true) - bypassHomeGate, vezi comentariul de la
        // definitia functiei (bug real 2026-09-07): la controllerchange userul
        // poate fi pe ORICE pagina autentificata, nu doar Home, iar update-ul
        // tocmai a sters cache-ul vechi (activate) - gate-ul de "doar pe Home"
        // ar lasa cele 3 formulare + /offline-queue needisponibile offline
        // pana la urmatoarea vizita reala pe Home, care poate sa nu se mai
        // intample inainte ca userul sa ajunga offline in teren.
        // prewarmIconFont() e apelata SEPARAT, neconditionat de pagina - spre
        // deosebire de cele 4 formulare (cai relative cunoscute doar in acest
        // script), <link>-ul de iconite e inclus global (fragments/head-assets),
        // deci descoperibil pe orice pagina autentificata.
        // Reincarcare automata a paginii curente cand un service worker nou
        // preia efectiv controlul (versiune noua de aplicatie disponibila) -
        // decizie explicita a userului 2026-08-28, dupa un bug real raportat
        // (fix de CSS livrat + deploy confirmat corect pe server cu curl, dar
        // tot invizibil pe telefon pana la o inchidere completa a aplicatiei):
        // fara reload, pagina deja deschisa ramane pe CSS/JS-ul vechi (cerut
        // de la vechiul service worker, cache-first fara revalidare) pana la
        // urmatoarea navigare manuala. Update-urile de aplicatie sunt rare,
        // riscul de a surprinde pe cineva completand un formular e acceptat
        // ca mic, in schimbul simplitatii (fara banner de "versiune noua
        // disponibila" + buton de confirmare). swReloadTriggered evita o
        // bucla daca evenimentul s-ar declansa de mai multe ori (ex. tab-uri
        // multiple deschise simultan) - o singura reincarcare per schimbare
        // reala de versiune.
        var swReloadTriggered = false;

        navigator.serviceWorker.addEventListener('controllerchange', function () {
            try {
                sessionStorage.removeItem(OFFLINE_PREWARM_FLAG);
            } catch (e) {
                // sessionStorage indisponibil (mod privat etc.) - prewarmOfflineForms()
                // oricum nu a putut seta throttle-ul mai devreme, nimic de curatat
            }
            prewarmOfflineForms(true);
            prewarmIconFont();

            if (swReloadTriggered) return;
            // Plasa de siguranta: NU reincarcam daca overlay-ul global de
            // incarcare e vizibil in acel moment - inseamna ca un submit/
            // upload chiar e in curs (POST clasic de formular, nu doar un
            // fetch() rezilient la navigare) - un reload l-ar intrerupe la
            // mijloc. Daca overlay-ul e activ acum, ramanem pe versiunea
            // veche pana la urmatoarea navigare normala a userului.
            if (loadingOverlayEl && loadingOverlayEl.classList.contains('loading-overlay-visible')) return;
            swReloadTriggered = true;
            window.location.reload();
        });
    }

    // Mini-harta din detaliile observatiei / formularul de validare Ranger
    // (fisa de testare B1, fragments/gps-details :: minimapRow). Leaflet si
    // map.js se incarca LA CERERE, doar cand pe pagina (sau in continutul adus
    // de htmx intr-un modal) apare un element [data-minimap] - restul paginilor
    // nu platesc costul hartii. URL-urile vin din atributele elementului (cu
    // context path si versiune corecte, randate de Thymeleaf).
    var minimapAssetsPromise = null;

    function loadScriptOnce(src) {
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    function loadMinimapAssets(el) {
        if (!minimapAssetsPromise) {
            var css = document.createElement('link');
            css.rel = 'stylesheet';
            css.href = el.dataset.leafletCss;
            document.head.appendChild(css);
            minimapAssetsPromise = (window.L ? Promise.resolve() : loadScriptOnce(el.dataset.leafletJs))
                .then(function () { return window.CaliMap ? null : loadScriptOnce(el.dataset.mapJs); });
            // la o eroare de retea, urmatoarea deschidere a detaliilor reincearca
            minimapAssetsPromise.catch(function () { minimapAssetsPromise = null; });
        }
        return minimapAssetsPromise;
    }

    function initMinimaps(root) {
        if (!root || !root.querySelectorAll) return;
        var elements = Array.prototype.slice.call(root.querySelectorAll('[data-minimap]:not([data-minimap-ready])'));
        if (root.matches && root.matches('[data-minimap]:not([data-minimap-ready])')) elements.push(root);
        elements.forEach(function (el) {
            el.setAttribute('data-minimap-ready', '');
            // doar rezumat (detalii deschise din harta mare): Leaflet + map.js sunt deja
            // pe pagina, nu mai adauga inca o data foaia de stil Leaflet
            var ready = el.hasAttribute('data-minimap-summary-only') && window.CaliMap
                ? Promise.resolve() : loadMinimapAssets(el);
            ready.then(function () {
                window.CaliMap.initMinimap(el);
            }).catch(function () {
                el.textContent = el.dataset.textLoadError;
            });
        });
    }

    document.body.addEventListener('htmx:load', function (evt) {
        initMinimaps(evt.detail.elt);
    });
    initMinimaps(document);

    // Galeria de poze din detaliile observatiei (fragments/photo-gallery.html): click pe o
    // miniatura, pe o sageata sau swipe pe poza mare (ultimele doua ciclic, ca pe harta) aduce
    // poza in poza mare, cu linkul spre original si legenda ei - miniaturile sunt sursa datelor
    // fiecarei poze. Delegare pe document - detaliile vin prin htmx in modal. Miniatura si poza
    // mare au ACELASI URL (o singura marime pe server), deci schimbarea vine din cache.
    function showGalleryPhoto(gallery, thumb) {
        var image = gallery.querySelector('[data-photo-gallery-image]');
        image.src = thumb.querySelector('img').src;
        image.alt = thumb.dataset.alt;
        gallery.querySelectorAll('[data-photo-gallery-link]').forEach(function (link) {
            link.href = thumb.dataset.original;
        });
        gallery.querySelector('[data-photo-gallery-caption]').textContent = thumb.dataset.caption;
        gallery.querySelectorAll('[data-photo-thumb]').forEach(function (other) {
            var active = other === thumb;
            other.classList.toggle('active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
    }

    function stepGalleryPhoto(gallery, step) {
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-photo-thumb]'));
        if (thumbs.length < 2) return;
        var current = thumbs.indexOf(gallery.querySelector('[data-photo-thumb].active'));
        showGalleryPhoto(gallery, thumbs[(current + step + thumbs.length) % thumbs.length]);
    }

    // swipe: doar pe orizontala (|dx| clar mai mare decat |dy|) - derularea verticala a
    // modalului ramane a browserului (touch-action: pan-y in main.scss); tap-ul simplu pe
    // poza deschide in continuare originalul, dar click-ul emis dupa un swipe e anulat
    var GALLERY_SWIPE_MIN_PX = 40;
    var gallerySwipe = null;
    var gallerySwipeClickBlockedUntil = 0;

    document.addEventListener('touchstart', function (evt) {
        var main = evt.target instanceof Element && evt.target.closest('[data-photo-gallery] .photo-gallery-main');
        gallerySwipe = main && evt.touches.length === 1
            ? { gallery: main.closest('[data-photo-gallery]'), x: evt.touches[0].clientX, y: evt.touches[0].clientY }
            : null;
    }, { passive: true });

    document.addEventListener('touchend', function (evt) {
        if (!gallerySwipe) return;
        var touch = evt.changedTouches[0];
        var dx = touch.clientX - gallerySwipe.x;
        var dy = touch.clientY - gallerySwipe.y;
        var gallery = gallerySwipe.gallery;
        gallerySwipe = null;
        if (Math.abs(dx) < GALLERY_SWIPE_MIN_PX || Math.abs(dx) < 1.5 * Math.abs(dy)) return;
        gallerySwipeClickBlockedUntil = Date.now() + 500;
        // spre stanga = poza urmatoare, ca in orice galerie de telefon
        stepGalleryPhoto(gallery, dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('touchcancel', function () {
        gallerySwipe = null;
    }, { passive: true });

    document.addEventListener('click', function (evt) {
        if (!(evt.target instanceof Element)) return;
        if (Date.now() < gallerySwipeClickBlockedUntil && evt.target.closest('[data-photo-gallery] .photo-gallery-main')) {
            evt.preventDefault();
            evt.stopPropagation();
            return;
        }
        var trigger = evt.target.closest('[data-photo-thumb], [data-photo-gallery-step]');
        if (!trigger) return;
        var gallery = trigger.closest('[data-photo-gallery]');
        if (trigger.hasAttribute('data-photo-gallery-step')) {
            stepGalleryPhoto(gallery, Number(trigger.dataset.photoGalleryStep));
        } else {
            showGalleryPhoto(gallery, trigger);
        }
    }, true);
})();
